/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: Date; output: Date; }
  Geometry: { input: any; output: any; }
  GeometryZ: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Long: { input: any; output: any; }
};

export enum ActionPosition {
  Bottom = 'BOTTOM',
  Right = 'RIGHT'
}

export type AlignmentEquationInput = {
  staAhead: Scalars['Float']['input'];
  staInternal: Scalars['Float']['input'];
};

/**
 * A client-side snapshot of a registry Alignment (app/src/core/alignment.ts:29).
 * Alignments are browser-owned; nothing on the server parses LandXML alignments.
 */
export type AlignmentInput = {
  /** Sorted by staInternal (alignment.ts:44). */
  equations?: InputMaybe<Array<AlignmentEquationInput>>;
  /** Registry key layerId:featureId (alignment.ts:53) — provenance. */
  key: Scalars['String']['input'];
  /** Owning layer, so the panel can warn when that layer was re-uploaded. */
  layerId?: InputMaybe<Scalars['ID']['input']>;
  /** Display name, echoed into the panel header, CSV and PDF. */
  name: Scalars['String']['input'];
  /** Tessellated centreline in project SRID, Float64, [[x,y,z], …]. 2 – 50 000 vertices. */
  points: Array<Array<Scalars['Float']['input']>>;
  /** FNV-1a-64 hex over quantised points (1 mm) + staStart + equations. */
  sourceHash: Scalars['String']['input'];
  /** staStart (alignment.ts:42). */
  staStart: Scalars['Float']['input'];
};

export type ApplyDiscountInput = {
  organizationId: Scalars['ID']['input'];
  promoCode: Scalars['String']['input'];
};

export type ArchiveBlockingJob = {
  __typename?: 'ArchiveBlockingJob';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ArchivePreview = {
  __typename?: 'ArchivePreview';
  archivableBytes: Scalars['Long']['output'];
  archivableFileCount: Scalars['Int']['output'];
  blockingJobs: Array<ArchiveBlockingJob>;
  monthlyCostArchived: Scalars['Float']['output'];
  monthlyCostCurrent: Scalars['Float']['output'];
  nonArchivableBytes: Scalars['Long']['output'];
  nonArchivableFileCount: Scalars['Int']['output'];
  quotaAfterArchive: Scalars['Long']['output'];
  retentionEndsAt: Scalars['DateTime']['output'];
  retrievalFeeEstimate: Scalars['Float']['output'];
};

export enum ArchiveStatus {
  Archived = 'ARCHIVED',
  ArchiveFailed = 'ARCHIVE_FAILED',
  Archiving = 'ARCHIVING',
  NotArchived = 'NOT_ARCHIVED',
  RestoreFailed = 'RESTORE_FAILED',
  RestoreRequested = 'RESTORE_REQUESTED',
  RestoreRetrieved = 'RESTORE_RETRIEVED',
  Restoring = 'RESTORING'
}

export type Attachment = {
  __typename?: 'Attachment';
  batch?: Maybe<UploadBatch>;
  batchId?: Maybe<Scalars['ID']['output']>;
  byproducts: Array<Byproduct>;
  checksumSHA256Base64?: Maybe<Scalars['String']['output']>;
  contentLength?: Maybe<Scalars['Long']['output']>;
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  projectId?: Maybe<Scalars['ID']['output']>;
  s3Key: Scalars['String']['output'];
  status: AttachmentStatus;
  updatedAt: Scalars['DateTime']['output'];
  uploadId?: Maybe<Scalars['ID']['output']>;
  url: Scalars['String']['output'];
};

export enum AttachmentStatus {
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Uploaded = 'UPLOADED',
  Uploading = 'UPLOADING'
}

export enum BillingInterval {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

export enum BillingStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  None = 'NONE',
  PastDue = 'PAST_DUE',
  PendingPayment = 'PENDING_PAYMENT',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type Byproduct = {
  __typename?: 'Byproduct';
  batchId?: Maybe<Scalars['ID']['output']>;
  contentLength?: Maybe<Scalars['Long']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  downloadUrl: Scalars['String']['output'];
  /**
   * When set, this byproduct is auto-deleted by the sweeper after this time
   * (e.g. 24h for clipbox exports). Null for permanent byproducts.
   */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * A data file a viewer feature reads for itself (station-volume arrays, the
   * clearance and stack documents), not a download. Layer menus and the data
   * centre hide it; `batch.byproducts` still lists it for the docks.
   */
  isInternal: Scalars['Boolean']['output'];
  processJobId: Scalars['ID']['output'];
  sourceAttachmentId?: Maybe<Scalars['ID']['output']>;
  type: ByproductType;
};

export enum ByproductType {
  Csv = 'CSV',
  Dwg = 'DWG',
  Dxf = 'DXF',
  E57 = 'E57',
  Geojson = 'GEOJSON',
  Geotiff = 'GEOTIFF',
  Gpkg = 'GPKG',
  Landxml = 'LANDXML',
  Laz = 'LAZ',
  Mesh = 'MESH',
  Other = 'OTHER',
  Pdf = 'PDF',
  Png = 'PNG',
  Rcs = 'RCS',
  Zip = 'ZIP'
}

export type ChangePlanInput = {
  organizationId: Scalars['ID']['input'];
  plan: SubscriptionPlan;
};

/**
 * A saved clearance profile — a closed polygon of [offsetM, heightM] vertices,
 * org-scoped and reusable across projects. Presets (Rectangle / Trapezoid /
 * railway gauge) are client-side vertex GENERATORS, not rows in this table.
 */
export type ClearanceProfile = {
  __typename?: 'ClearanceProfile';
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Published-standard citation, for a copy saved from a shipped preset
   * ("Dimensions per Transport Canada E-05, Diagram 1 — verify against the
   * current standard"). Null for a hand-drawn profile. Max 300 characters.
   */
  sourceAttribution?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** [[offsetM, heightM], …]. First vertex is NOT repeated — the polygon is implicitly closed. */
  vertices: Array<Array<Scalars['Float']['output']>>;
};

/**
 * The profile as it is snapshotted INTO a run (spec §1's snapshot rule). Sent by
 * value, never by id: editing or deleting the saved profile must never change
 * what an existing analysis meant.
 */
export type ClearanceProfileSnapshotInput = {
  name: Scalars['String']['input'];
  /**
   * The standard the dimensions came from, snapshotted with them (ruling K4) so
   * a run can always be traced to its source. Max 300 characters.
   */
  sourceAttribution?: InputMaybe<Scalars['String']['input']>;
  vertices: Array<Array<Scalars['Float']['input']>>;
};

export type ClipBoxInput = {
  /** World-space center, length 3 (x, y, z). */
  center: Array<Scalars['Float']['input']>;
  /** Half-extent per axis, length 3, world-units (m). */
  halfSize: Array<Scalars['Float']['input']>;
  /** Quaternion (qx, qy, qz, qw), length 4. */
  rotation: Array<Scalars['Float']['input']>;
};

export enum ClipboxExportFormat {
  E57 = 'E57',
  Laz = 'LAZ'
}

export enum CollectionMethod {
  Automatic = 'AUTOMATIC',
  SendInvoice = 'SEND_INVOICE'
}

export type CreateAttachmentResponse = {
  __typename?: 'CreateAttachmentResponse';
  attachment: Attachment;
  uploadUrl: Scalars['String']['output'];
};

export type CreateCustomSubscriptionInput = {
  billingInterval: BillingInterval;
  maxSeats: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  productLine: ProductLine;
  storageLimitBytes: Scalars['Long']['input'];
  stripePriceId: Scalars['String']['input'];
};

export type CreateFeatureAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
  featureId: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type CreateFeatureInput = {
  geometry: Scalars['GeometryZ']['input'];
  geometryWGS84?: InputMaybe<Scalars['GeometryZ']['input']>;
  layerId: Scalars['ID']['input'];
  properties: Scalars['JSON']['input'];
};

export type CreateImageInput = {
  attachmentId: Scalars['ID']['input'];
  layerId: Scalars['ID']['input'];
  location: Scalars['Geometry']['input'];
  locationWGS84: Scalars['Geometry']['input'];
  projectId: Scalars['ID']['input'];
};

export type CreateLayerInput = {
  bbox?: InputMaybe<Scalars['Geometry']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentLayerId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  type: LayerType;
};

export type CreateOrganizationInput = {
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type CreateProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  srid: Scalars['Int']['input'];
};

export type CreateSavedViewInput = {
  baseMapId?: InputMaybe<Scalars['ID']['input']>;
  camera: Scalars['JSON']['input'];
  clipBox: Scalars['JSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  visibility: SavedViewVisibility;
  visibleLayerIds: Array<Scalars['ID']['input']>;
};

export type CreateSubscriptionInput = {
  billingInterval: BillingInterval;
  cancelUrl: Scalars['String']['input'];
  collectionMethod: CollectionMethod;
  organizationId: Scalars['ID']['input'];
  plan: SubscriptionPlan;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  successUrl: Scalars['String']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubscriptionResult = {
  __typename?: 'CreateSubscriptionResult';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * One lane band, as a SIGNED-free offset range on one side of the
 * centreline: the left band covers offsets −toM … −fromM, the right band
 * fromM … toM. `0 ≤ fromM < toM`, and the band must be at least 1 m wide.
 */
export type CrossfallBandInput = {
  fromM: Scalars['Float']['input'];
  toM: Scalars['Float']['input'];
};

/**
 * Crossfall (cross-slope) check. At every station line the worker fits a
 * least-squares line of elevation against the UNSIGNED offset over each band,
 * on the as-built plane and on the design plane, and judges the difference.
 */
export type CrossfallInput = {
  /** Left and right bands. Either may be omitted; at least one is required. */
  left?: InputMaybe<CrossfallBandInput>;
  right?: InputMaybe<CrossfallBandInput>;
  /** Absolute tolerance on Δ crossfall, percent. 0.05 – 5, default 0.3. */
  tolerancePct: Scalars['Float']['input'];
};

export type CustomBaseMap = {
  __typename?: 'CustomBaseMap';
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tileSize?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
  wmsLayers?: Maybe<Scalars['String']['output']>;
  wmsVersion?: Maybe<Scalars['String']['output']>;
};

export type CustomBaseMapInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  tileSize?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
  wmsLayers?: InputMaybe<Scalars['String']['input']>;
  wmsVersion?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomDomainStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Failed = 'FAILED',
  PendingDns = 'PENDING_DNS'
}

export type DailyViews = {
  __typename?: 'DailyViews';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type DashboardProject = {
  __typename?: 'DashboardProject';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  layerCounts: Array<LayerTypeCount>;
  name: Scalars['String']['output'];
  positionWGS84?: Maybe<Scalars['Geometry']['output']>;
  storageUsedBytes: Scalars['Long']['output'];
};

export type DashboardStats = {
  __typename?: 'DashboardStats';
  layerTypeCounts: Array<LayerTypeCount>;
  projects: Array<DashboardProject>;
  totalLayers: Scalars['Int']['output'];
};

export type DeviationParamsInput = {
  colormap?: InputMaybe<Scalars['String']['input']>;
  decimate?: InputMaybe<Scalars['Int']['input']>;
  ifcName?: InputMaybe<Scalars['String']['input']>;
  ifcTypes?: InputMaybe<Scalars['String']['input']>;
  kNearestTriangles?: InputMaybe<Scalars['Int']['input']>;
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
  mode: Scalars['String']['input'];
  outTif?: InputMaybe<Scalars['Boolean']['input']>;
  referenceCellStat?: InputMaybe<Scalars['String']['input']>;
  referenceInterp?: InputMaybe<Scalars['String']['input']>;
  referenceMode?: InputMaybe<Scalars['String']['input']>;
  referenceResolution?: InputMaybe<Scalars['Float']['input']>;
  renderColormap?: InputMaybe<Scalars['String']['input']>;
  renderImageSize?: InputMaybe<Scalars['Int']['input']>;
  renderPerSurface?: InputMaybe<Scalars['Boolean']['input']>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  tifResolution?: InputMaybe<Scalars['Float']['input']>;
  tifSrid?: InputMaybe<Scalars['Int']['input']>;
  tifStat?: InputMaybe<Scalars['String']['input']>;
  verticalThreshold?: InputMaybe<Scalars['Float']['input']>;
  volumeHistBins?: InputMaybe<Scalars['Int']['input']>;
  volumePlane?: InputMaybe<Scalars['String']['input']>;
  volumeResolution?: InputMaybe<Scalars['Float']['input']>;
  volumeStats?: InputMaybe<Scalars['Boolean']['input']>;
  volumeTolerance?: InputMaybe<Scalars['Float']['input']>;
};

export type DeviationSectionInput = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
  layerId: Scalars['ID']['input'];
};

export type DiscountInfo = {
  __typename?: 'DiscountInfo';
  amountOff?: Maybe<Scalars['Int']['output']>;
  couponId: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Float']['output']>;
  promoCodeId?: Maybe<Scalars['String']['output']>;
};

export enum ExportCrs {
  /** Export in the project's native/projected CRS (from the stored geometry). */
  Project = 'PROJECT',
  /** Export in WGS84 (EPSG:4326). */
  Wgs84 = 'WGS84'
}

export enum ExportType {
  Csv = 'CSV',
  Geojson = 'GEOJSON'
}

export type Feature = {
  __typename?: 'Feature';
  createdAt: Scalars['DateTime']['output'];
  geometry: Scalars['GeometryZ']['output'];
  geometryWGS84: Scalars['GeometryZ']['output'];
  id: Scalars['ID']['output'];
  layerId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  properties: Scalars['JSON']['output'];
  serial: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FeatureAttachment = {
  __typename?: 'FeatureAttachment';
  attachment: Attachment;
  attachmentId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadedBy: User;
  uploadedById: Scalars['ID']['output'];
};

export type FeatureFilter = {
  key: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type FeatureOrder = {
  direction?: OrderDirection;
  field: Scalars['String']['input'];
};

export type FeaturePaginated = {
  __typename?: 'FeaturePaginated';
  cursor?: Maybe<Scalars['String']['output']>;
  features: Array<Feature>;
  total: Scalars['Int']['output'];
};

export type FeatureSummary = {
  __typename?: 'FeatureSummary';
  lineCount: Scalars['Int']['output'];
  pointCount: Scalars['Int']['output'];
  polygonCount: Scalars['Int']['output'];
  totalLineLengthM: Scalars['Float']['output'];
  totalPolygonAreaSqm: Scalars['Float']['output'];
  totalPolygonPerimeterM: Scalars['Float']['output'];
};

export type FeaturebaseUser = {
  __typename?: 'FeaturebaseUser';
  email?: Maybe<Scalars['String']['output']>;
  featurebaseJwt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Scalars['String']['output'];
  profilePicture?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type GoogleImage = {
  __typename?: 'GoogleImage';
  copyright: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['String']['output'];
  heading: Scalars['Float']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  locationWGS84: Scalars['GeometryZ']['output'];
  panoId: Scalars['String']['output'];
  roll: Scalars['Float']['output'];
  root: Scalars['String']['output'];
  tilt: Scalars['Float']['output'];
  width: Scalars['Int']['output'];
};

export type GroundClassifyParamsInput = {
  algorithm: Scalars['String']['input'];
  classifyAllReturns?: InputMaybe<Scalars['Boolean']['input']>;
  colormap?: InputMaybe<Scalars['String']['input']>;
  csfHdiff?: InputMaybe<Scalars['Float']['input']>;
  csfIterations?: InputMaybe<Scalars['Int']['input']>;
  csfResolution?: InputMaybe<Scalars['Float']['input']>;
  csfRigidness?: InputMaybe<Scalars['Int']['input']>;
  csfSmooth?: InputMaybe<Scalars['Boolean']['input']>;
  csfStep?: InputMaybe<Scalars['Float']['input']>;
  csfThreshold?: InputMaybe<Scalars['Float']['input']>;
  rasterOutputType?: InputMaybe<Scalars['String']['input']>;
  resetClassification?: InputMaybe<Scalars['Boolean']['input']>;
  resolution: Scalars['Float']['input'];
  rgbHiPct?: InputMaybe<Scalars['Float']['input']>;
  rgbLoPct?: InputMaybe<Scalars['Float']['input']>;
  runElm?: InputMaybe<Scalars['Boolean']['input']>;
  runOutlier?: InputMaybe<Scalars['Boolean']['input']>;
  smrfCell?: InputMaybe<Scalars['Float']['input']>;
  smrfCut?: InputMaybe<Scalars['Float']['input']>;
  smrfScalar?: InputMaybe<Scalars['Float']['input']>;
  smrfSlope?: InputMaybe<Scalars['Float']['input']>;
  smrfThreshold?: InputMaybe<Scalars['Float']['input']>;
  smrfWindow?: InputMaybe<Scalars['Float']['input']>;
  writeCount?: InputMaybe<Scalars['Boolean']['input']>;
  writeRgbDtm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Image = {
  __typename?: 'Image';
  attachmentId?: Maybe<Scalars['ID']['output']>;
  blurredFilename?: Maybe<Scalars['String']['output']>;
  cameraType?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  filename: Scalars['String']['output'];
  focalLengthX?: Maybe<Scalars['Float']['output']>;
  focalLengthY?: Maybe<Scalars['Float']['output']>;
  groupId: Scalars['Int']['output'];
  hasBlurredVariants: Scalars['Boolean']['output'];
  hasCompressedVariants: Scalars['Boolean']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  k1?: Maybe<Scalars['Float']['output']>;
  k2?: Maybe<Scalars['Float']['output']>;
  k3?: Maybe<Scalars['Float']['output']>;
  k4?: Maybe<Scalars['Float']['output']>;
  largeBlurredFilename?: Maybe<Scalars['String']['output']>;
  largeFilename?: Maybe<Scalars['String']['output']>;
  layer: Layer;
  layerId?: Maybe<Scalars['ID']['output']>;
  location: Scalars['Geometry']['output'];
  locationWGS84: Scalars['Geometry']['output'];
  organizationId: Scalars['ID']['output'];
  p1?: Maybe<Scalars['Float']['output']>;
  p2?: Maybe<Scalars['Float']['output']>;
  pixelHeight: Scalars['Float']['output'];
  pixelWidth: Scalars['Float']['output'];
  principalPointX?: Maybe<Scalars['Float']['output']>;
  principalPointY?: Maybe<Scalars['Float']['output']>;
  projectId: Scalars['ID']['output'];
  rotationMatrix: Array<Scalars['Float']['output']>;
  rotationQuaternion: Array<Scalars['Float']['output']>;
  smallBlurredFilename?: Maybe<Scalars['String']['output']>;
  smallFilename?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  width: Scalars['Int']['output'];
};

export type ImageAnnotation = {
  __typename?: 'ImageAnnotation';
  confidence: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  type: ImageAnnotationType;
  updatedAt: Scalars['DateTime']['output'];
  x1: Scalars['Float']['output'];
  x2: Scalars['Float']['output'];
  y1: Scalars['Float']['output'];
  y2: Scalars['Float']['output'];
};

export enum ImageAnnotationType {
  Face = 'FACE',
  LicensePlate = 'LICENSE_PLATE'
}

export type InviteUserInput = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname?: InputMaybe<Scalars['String']['input']>;
  role: UserOrganizationRole;
};

export type Invoice = {
  __typename?: 'Invoice';
  amountDue: Scalars['Int']['output'];
  amountPaid: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  number?: Maybe<Scalars['String']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  taxInvoiceNumber?: Maybe<Scalars['String']['output']>;
  taxInvoiceUrl?: Maybe<Scalars['String']['output']>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  amount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type InvoicePreview = {
  __typename?: 'InvoicePreview';
  amountDue: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  lines: Array<InvoiceLineItem>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
};

export type LandxmlCategoryColors = {
  __typename?: 'LandxmlCategoryColors';
  alignment: Scalars['String']['output'];
  breakline: Scalars['String']['output'];
  parcel: Scalars['String']['output'];
  pipe: Scalars['String']['output'];
  structure: Scalars['String']['output'];
  surface: Scalars['String']['output'];
};

export type LandxmlCategoryColorsInput = {
  alignment: Scalars['String']['input'];
  breakline: Scalars['String']['input'];
  parcel: Scalars['String']['input'];
  pipe: Scalars['String']['input'];
  structure: Scalars['String']['input'];
  surface: Scalars['String']['input'];
};

/**
 * One named subset of the selection. Each group becomes its OWN export job,
 * LandXML file and layer — that is how a model whose only real structure is a
 * property value (or a CAD layer) is split into one surface file per course.
 */
export type LandxmlExportGroupInput = {
  /** IfcGloballyUniqueIds in this group. Must not be empty. */
  guids: Array<Scalars['String']['input']>;
  /**
   * Group name. Used for the layer name and, because the models that need
   * grouping are the ones whose products are unnamed, for the surface names too.
   */
  name: Scalars['String']['input'];
};

export type Layer = {
  __typename?: 'Layer';
  bbox?: Maybe<Scalars['Geometry']['output']>;
  bboxNew?: Maybe<Scalars['Geometry']['output']>;
  center?: Maybe<Scalars['Geometry']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ephemeralExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  ephemeralSourceBytes?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  isEphemeral: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  parentLayerId?: Maybe<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  propertyAliases: Array<PropertyAlias>;
  root?: Maybe<Scalars['String']['output']>;
  settings: LayerSettings;
  sourceAttachment?: Maybe<Attachment>;
  sourceAttachmentId?: Maybe<Scalars['ID']['output']>;
  subLayers: Array<Layer>;
  type: LayerType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

export type LayerSettings = {
  __typename?: 'LayerSettings';
  imageBrightness: Scalars['Float']['output'];
  imageContrast: Scalars['Float']['output'];
  imageOpacity: Scalars['Float']['output'];
  imagePointColor: Scalars['String']['output'];
  imageSaturation: Scalars['Float']['output'];
  landxmlCategoryColors: LandxmlCategoryColors;
  landxmlSurfaceColorMode: Scalars['String']['output'];
  landxmlSurfaceColormap: PointColorType;
  modelClassColors: Array<ModelClassColor>;
  modelColorBy: Scalars['String']['output'];
  modelDefaultColor: Scalars['String']['output'];
  modelIsWireframe: Scalars['Boolean']['output'];
  modelOpacity: Scalars['Float']['output'];
  offsetX: Scalars['Float']['output'];
  offsetY: Scalars['Float']['output'];
  offsetZ: Scalars['Float']['output'];
  pointCloudClasses: Array<PointCloudClassSettings>;
  pointCloudFixedColor: Scalars['String']['output'];
  pointCloudMaterialColor: PointColorType;
  pointCloudMaterialColorSource: Scalars['Int']['output'];
  rasterBrightness: Scalars['Float']['output'];
  rasterContrast: Scalars['Float']['output'];
  rasterOpacity: Scalars['Float']['output'];
  rasterSaturation: Scalars['Float']['output'];
  rotationX: Scalars['Float']['output'];
  rotationY: Scalars['Float']['output'];
  rotationZ: Scalars['Float']['output'];
  scalarRangeMax?: Maybe<Scalars['Float']['output']>;
  scalarRangeMin?: Maybe<Scalars['Float']['output']>;
  sectionOverlays: Array<SectionOverlaySetting>;
  surfaceDifferenceColormap: PointColorType;
  vectorDefaultColor: Scalars['String']['output'];
  vectorDefaultOpacity: Scalars['Float']['output'];
  vectorDefaultPointSize: Scalars['Float']['output'];
  vectorIsWireframe: Scalars['Boolean']['output'];
  vectorLineRenderAsPipe: Scalars['Boolean']['output'];
  vectorLineWidth: Scalars['Float']['output'];
  vectorSurfaceColorMode: Scalars['String']['output'];
  vectorSurfaceColormap: PointColorType;
};

export type LayerSettingsInput = {
  imageBrightness: Scalars['Float']['input'];
  imageContrast: Scalars['Float']['input'];
  imageOpacity: Scalars['Float']['input'];
  imagePointColor: Scalars['String']['input'];
  imageSaturation: Scalars['Float']['input'];
  landxmlCategoryColors: LandxmlCategoryColorsInput;
  landxmlSurfaceColorMode: Scalars['String']['input'];
  landxmlSurfaceColormap: PointColorType;
  modelClassColors: Array<ModelClassColorInput>;
  modelColorBy: Scalars['String']['input'];
  modelDefaultColor: Scalars['String']['input'];
  modelIsWireframe: Scalars['Boolean']['input'];
  modelOpacity: Scalars['Float']['input'];
  offsetX: Scalars['Float']['input'];
  offsetY: Scalars['Float']['input'];
  offsetZ: Scalars['Float']['input'];
  pointCloudClasses: Array<PointCloudClassSettingsInput>;
  pointCloudFixedColor: Scalars['String']['input'];
  pointCloudMaterialColor: PointColorType;
  pointCloudMaterialColorSource: Scalars['Int']['input'];
  rasterBrightness: Scalars['Float']['input'];
  rasterContrast: Scalars['Float']['input'];
  rasterOpacity: Scalars['Float']['input'];
  rasterSaturation: Scalars['Float']['input'];
  rotationX: Scalars['Float']['input'];
  rotationY: Scalars['Float']['input'];
  rotationZ: Scalars['Float']['input'];
  scalarRangeMax?: InputMaybe<Scalars['Float']['input']>;
  scalarRangeMin?: InputMaybe<Scalars['Float']['input']>;
  sectionOverlays?: InputMaybe<Array<SectionOverlaySettingInput>>;
  surfaceDifferenceColormap: PointColorType;
  vectorDefaultColor: Scalars['String']['input'];
  vectorDefaultOpacity: Scalars['Float']['input'];
  vectorDefaultPointSize: Scalars['Float']['input'];
  vectorIsWireframe: Scalars['Boolean']['input'];
  vectorLineRenderAsPipe: Scalars['Boolean']['input'];
  vectorLineWidth: Scalars['Float']['input'];
  vectorSurfaceColorMode: Scalars['String']['input'];
  vectorSurfaceColormap: PointColorType;
};

export type LayerStackLevelInput = {
  /** Omit when this level has not been surveyed yet — that is PENDING, not an error. */
  asBuilt?: InputMaybe<SurfaceInput>;
  /** The design surface for this level. Its difference with the next level's design IS the design thickness. */
  design?: InputMaybe<SurfaceInput>;
  /** Top to bottom. The name identifies this level in the CSV, report and chip strip. */
  name: Scalars['String']['input'];
  overToleranceM?: InputMaybe<Scalars['Float']['input']>;
  underToleranceM?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Knobs for the multi-layer thickness analysis (spec: multi-layer-thickness).
 * `resolution` is the analysis grid cell size in metres, the same role
 * `SurfaceDifferenceParamsInput.resolution` plays for a single surface pair —
 * `scripts/stack_analysis.py::analyse_stack` takes it as a required kwarg.
 */
export type LayerStackParamsInput = {
  resolution: Scalars['Float']['input'];
};

/**
 * The multi-layer thickness report (spec §7). ONE section here becomes MANY
 * resolved sections in the document: the stack's own summary plus one station
 * section per LAYER (N levels give N-1 layers), assembled server-side by
 * `preprocess.ts`. The caller names only the stack RESULT layer.
 */
export type LayerStackSectionInput = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
  /** The LAYER_STACK result layer carrying metadata.layerStack. */
  layerId: Scalars['ID']['input'];
  /**
   * Internal stations; omit for the whole analysis. Applied to EVERY layer —
   * the station page budget is shared across them (400 bins for the whole
   * report, not per layer), so narrowing here is how a deep stack fits.
   */
  stationFrom?: InputMaybe<Scalars['Float']['input']>;
  stationTo?: InputMaybe<Scalars['Float']['input']>;
};

export enum LayerType {
  Group = 'GROUP',
  Image = 'IMAGE',
  Model = 'MODEL',
  Pointcloud = 'POINTCLOUD',
  Tile = 'TILE',
  Vector = 'VECTOR',
  Wms = 'WMS'
}

export type LayerTypeCount = {
  __typename?: 'LayerTypeCount';
  count: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type LinkView = {
  __typename?: 'LinkView';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  linkId: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  sessionId: Scalars['String']['output'];
};

export type LinkWithViews = {
  __typename?: 'LinkWithViews';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  viewCount: Scalars['Int']['output'];
};

export enum MeshAlgorithm {
  SurfacePoisson = 'SURFACE_POISSON',
  TerrainTin = 'TERRAIN_TIN'
}

export enum MeshOutputFormat {
  Glb = 'GLB',
  Obj = 'OBJ',
  Ply = 'PLY',
  Stl = 'STL'
}

export type ModelClassColor = {
  __typename?: 'ModelClassColor';
  class: Scalars['String']['output'];
  color: Scalars['String']['output'];
};

export type ModelClassColorInput = {
  class: Scalars['String']['input'];
  color: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  abortUpload: Scalars['Boolean']['output'];
  acceptInvitation: UserInvitationResult;
  addCustomDomain: OrganizationCustomDomain;
  addProjectBaseMap: Project;
  applySubscriptionDiscount: Scalars['Boolean']['output'];
  archiveProject: Project;
  cancelSubscription: Scalars['Boolean']['output'];
  changeSubscriptionPlan: Scalars['Boolean']['output'];
  completeBatch: Scalars['Boolean']['output'];
  completeUpload: Attachment;
  createAttachment: CreateAttachmentResponse;
  createBillingPortalSession: Scalars['String']['output'];
  createCustomSubscription: CreateSubscriptionResult;
  createFeature: Feature;
  createFeatureAttachment: FeatureAttachment;
  createImage: Image;
  createLayer: Layer;
  createOrganization: Organization;
  createProject: Project;
  createProjectFolder: ProjectFolder;
  createProjectLink: ProjectLink;
  createReferral: Referral;
  createSavedView: SavedView;
  createSubscription: CreateSubscriptionResult;
  deleteArchivedProject: Scalars['Boolean']['output'];
  deleteAttachment: Scalars['Boolean']['output'];
  deleteBatch: Scalars['Boolean']['output'];
  deleteClearanceProfile: Scalars['Boolean']['output'];
  deleteFeature: Scalars['Boolean']['output'];
  deleteFeatureAttachment: Scalars['Boolean']['output'];
  deleteFeatures: Scalars['Boolean']['output'];
  deleteImage: Scalars['Boolean']['output'];
  deleteLayer: Scalars['Boolean']['output'];
  deleteOrganization: Scalars['Boolean']['output'];
  deletePasskey: Scalars['Boolean']['output'];
  deleteProject: Scalars['Boolean']['output'];
  deleteProjectBaseMap: Project;
  deleteProjectFolder: Scalars['Boolean']['output'];
  deleteProjectLink: Scalars['Boolean']['output'];
  deleteReferral: Scalars['Boolean']['output'];
  deleteSavedView: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  disableAuthenticatorTwoFactor: Scalars['Boolean']['output'];
  disableTwoFactor: Scalars['Boolean']['output'];
  downloadFeatures: Scalars['String']['output'];
  inviteOnboardingUsers: Scalars['Boolean']['output'];
  inviteUserToOrganization: Scalars['Boolean']['output'];
  inviteUsersToOrganization: Scalars['Boolean']['output'];
  /**
   * Sample the section overlays configured in this result layer's
   * `settings.sectionOverlays` onto its station grid (a SECTION_OVERLAYS job).
   * Returns the analysis batch id. Call after every change to the list.
   */
  materializeSectionOverlays: Scalars['ID']['output'];
  moveProjectToFolder: Project;
  quickUploadLayer: QuickUploadLayerResult;
  reactivateSubscription: Scalars['Boolean']['output'];
  refreshWmsLayer: Layer;
  removeCustomDomain: Scalars['Boolean']['output'];
  removeSubscriptionDiscount: Scalars['Boolean']['output'];
  removeUserFromOrganization: Scalars['Boolean']['output'];
  renamePasskey: Scalars['Boolean']['output'];
  renameProjectFolder: ProjectFolder;
  resendInvitation: Scalars['Boolean']['output'];
  resetBatch: Scalars['Boolean']['output'];
  restoreProject: Project;
  revokeInvitation: Scalars['Boolean']['output'];
  revokeSession: Scalars['Boolean']['output'];
  saveClearanceProfile: ClearanceProfile;
  saveOnboardingSurvey: Scalars['Boolean']['output'];
  setupAuthenticatorTwoFactor: SetupAuthenticatorResult;
  setupTwoFactor: SetupTwoFactorResult;
  startBatch: UploadBatch;
  startBatchProcessing: Scalars['Boolean']['output'];
  startClearance: Scalars['ID']['output'];
  startClipboxExport: Scalars['ID']['output'];
  startDeviationAnalysis: Scalars['ID']['output'];
  startGroundClassification: Scalars['ID']['output'];
  startLandxmlExport: Scalars['ID']['output'];
  startLayerStack: Scalars['ID']['output'];
  startMeshExport: Scalars['ID']['output'];
  startPdfReport: Scalars['ID']['output'];
  startRainfallAnalysis: Scalars['ID']['output'];
  startSurfaceDifference: Scalars['ID']['output'];
  startUpload: Attachment;
  startVectorExport: Scalars['ID']['output'];
  touchEphemeralLayers: Scalars['Boolean']['output'];
  updateEmail: Scalars['Boolean']['output'];
  updateFeature: Feature;
  updateFeatureAttachment: FeatureAttachment;
  updateFeatures: Array<Feature>;
  updateImage: Image;
  updateLanguage: Scalars['Boolean']['output'];
  updateLayer: Layer;
  updateLayerSettings: Scalars['Boolean']['output'];
  updateLayersSettings: Scalars['Boolean']['output'];
  updateOrganization: Organization;
  updatePassword: Scalars['Boolean']['output'];
  updateProject: Project;
  updateProjectBaseMap: Project;
  updateProjectLinkAllowQuickUploads: ProjectLink;
  updateProjectLinkPassword: ProjectLink;
  updateSavedView: SavedView;
  updateTheme: Scalars['Boolean']['output'];
  updateUser: User;
  updateUserRoleInOrganization: Scalars['Boolean']['output'];
  updateViewerSettings: Scalars['Boolean']['output'];
  uploadPart: Scalars['String']['output'];
  verifyAuthenticatorTwoFactorSetup: Scalars['Boolean']['output'];
  verifyTwoFactorSetup: Scalars['Boolean']['output'];
};


export type MutationAbortUploadArgs = {
  attachmentId: Scalars['ID']['input'];
};


export type MutationAcceptInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationAddCustomDomainArgs = {
  domain: Scalars['String']['input'];
};


export type MutationAddProjectBaseMapArgs = {
  input: CustomBaseMapInput;
  projectId: Scalars['ID']['input'];
};


export type MutationApplySubscriptionDiscountArgs = {
  input: ApplyDiscountInput;
};


export type MutationArchiveProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelSubscriptionArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationChangeSubscriptionPlanArgs = {
  input: ChangePlanInput;
};


export type MutationCompleteBatchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompleteUploadArgs = {
  attachmentId: Scalars['ID']['input'];
  parts: Array<S3CompletedPart>;
};


export type MutationCreateAttachmentArgs = {
  checksumSHA256Base64?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  project?: InputMaybe<Scalars['ID']['input']>;
  type: UploadType;
};


export type MutationCreateBillingPortalSessionArgs = {
  organizationId: Scalars['ID']['input'];
  returnUrl: Scalars['String']['input'];
};


export type MutationCreateCustomSubscriptionArgs = {
  input: CreateCustomSubscriptionInput;
};


export type MutationCreateFeatureArgs = {
  input: CreateFeatureInput;
};


export type MutationCreateFeatureAttachmentArgs = {
  input: CreateFeatureAttachmentInput;
};


export type MutationCreateImageArgs = {
  input: CreateImageInput;
};


export type MutationCreateLayerArgs = {
  input: CreateLayerInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateProjectFolderArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateProjectLinkArgs = {
  allowQuickUploads?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationCreateReferralArgs = {
  email: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSavedViewArgs = {
  input: CreateSavedViewInput;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationDeleteArchivedProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAttachmentArgs = {
  attachmentId: Scalars['ID']['input'];
};


export type MutationDeleteBatchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClearanceProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeatureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeatureAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeaturesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteImageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLayerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
};


export type MutationDeletePasskeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectBaseMapArgs = {
  baseMapId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationDeleteProjectFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReferralArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSavedViewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
};


export type MutationDisableAuthenticatorTwoFactorArgs = {
  code: Scalars['String']['input'];
};


export type MutationDisableTwoFactorArgs = {
  code: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


export type MutationDownloadFeaturesArgs = {
  exportType: ExportType;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  layerId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationInviteOnboardingUsersArgs = {
  invitees: Array<OnboardingInviteInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationInviteUserToOrganizationArgs = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  role: UserOrganizationRole;
};


export type MutationInviteUsersToOrganizationArgs = {
  invitees: Array<InviteUserInput>;
  organizationId: Scalars['ID']['input'];
};


export type MutationMaterializeSectionOverlaysArgs = {
  layerId: Scalars['ID']['input'];
};


export type MutationMoveProjectToFolderArgs = {
  folderId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationQuickUploadLayerArgs = {
  input: QuickUploadLayerInput;
};


export type MutationReactivateSubscriptionArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationRefreshWmsLayerArgs = {
  layerId: Scalars['ID']['input'];
};


export type MutationRemoveSubscriptionDiscountArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRenamePasskeyArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationRenameProjectFolderArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationResendInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetBatchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeSessionArgs = {
  sessionId: Scalars['ID']['input'];
};


export type MutationSaveClearanceProfileArgs = {
  input: SaveClearanceProfileInput;
};


export type MutationSaveOnboardingSurveyArgs = {
  data: Scalars['JSON']['input'];
};


export type MutationSetupTwoFactorArgs = {
  mobileNumber: Scalars['String']['input'];
};


export type MutationStartBatchArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
  numberOfAttachments: Scalars['Int']['input'];
  project: Scalars['ID']['input'];
};


export type MutationStartBatchProcessingArgs = {
  blurFaces?: InputMaybe<Scalars['Boolean']['input']>;
  blurLicensePlates?: InputMaybe<Scalars['Boolean']['input']>;
  compressImages?: InputMaybe<Scalars['Boolean']['input']>;
  dxfOutputVersion?: InputMaybe<Scalars['String']['input']>;
  generateDecimatedPointCloud?: InputMaybe<Scalars['Boolean']['input']>;
  generateGeotiff?: InputMaybe<Scalars['Boolean']['input']>;
  generateRcs?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  importUrl?: InputMaybe<Scalars['String']['input']>;
  maxZoom?: InputMaybe<Scalars['Int']['input']>;
  minZoom?: InputMaybe<Scalars['Int']['input']>;
  pointCloudAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  rasterMode?: InputMaybe<Scalars['String']['input']>;
  srid: Scalars['Int']['input'];
  tileSize?: InputMaybe<Scalars['Int']['input']>;
  type: ProcessJobType;
};


export type MutationStartClearanceArgs = {
  input: StartClearanceInput;
};


export type MutationStartClipboxExportArgs = {
  input: StartClipboxExportInput;
};


export type MutationStartDeviationAnalysisArgs = {
  input: StartDeviationAnalysisInput;
};


export type MutationStartGroundClassificationArgs = {
  input: StartGroundClassificationInput;
};


export type MutationStartLandxmlExportArgs = {
  input: StartLandxmlExportInput;
};


export type MutationStartLayerStackArgs = {
  input: StartLayerStackInput;
};


export type MutationStartMeshExportArgs = {
  input: StartMeshExportInput;
};


export type MutationStartPdfReportArgs = {
  input: StartPdfReportInput;
};


export type MutationStartRainfallAnalysisArgs = {
  input: StartRainfallAnalysisInput;
};


export type MutationStartSurfaceDifferenceArgs = {
  input: StartSurfaceDifferenceInput;
};


export type MutationStartUploadArgs = {
  batch?: InputMaybe<Scalars['ID']['input']>;
  checksumSHA256Base64?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  project: Scalars['ID']['input'];
};


export type MutationStartVectorExportArgs = {
  input: StartVectorExportInput;
};


export type MutationTouchEphemeralLayersArgs = {
  layerIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateEmailArgs = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateFeatureArgs = {
  input: UpdateFeatureInput;
};


export type MutationUpdateFeatureAttachmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFeatureAttachmentInput;
};


export type MutationUpdateFeaturesArgs = {
  input: Array<UpdateFeatureInput>;
};


export type MutationUpdateImageArgs = {
  input: UpdateImageInput;
};


export type MutationUpdateLanguageArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLayerArgs = {
  input: UpdateLayerInput;
};


export type MutationUpdateLayerSettingsArgs = {
  id: Scalars['ID']['input'];
  input: LayerSettingsInput;
};


export type MutationUpdateLayersSettingsArgs = {
  input: Array<UpdateLayerSettingsBatchInput>;
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganizationInput;
};


export type MutationUpdatePasswordArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePasswordInput;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdateProjectBaseMapArgs = {
  baseMapId: Scalars['ID']['input'];
  input: CustomBaseMapInput;
  projectId: Scalars['ID']['input'];
};


export type MutationUpdateProjectLinkAllowQuickUploadsArgs = {
  allowQuickUploads: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateProjectLinkPasswordArgs = {
  id: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSavedViewArgs = {
  input: UpdateSavedViewInput;
};


export type MutationUpdateThemeArgs = {
  theme: ThemePreference;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};


export type MutationUpdateUserRoleInOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  role: UserOrganizationRole;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateViewerSettingsArgs = {
  input: ViewerSettingsInput;
};


export type MutationUploadPartArgs = {
  attachmentId: Scalars['ID']['input'];
  checksumSHA256Base64: Scalars['String']['input'];
  contentLength: Scalars['Int']['input'];
  partNumber: Scalars['Int']['input'];
};


export type MutationVerifyAuthenticatorTwoFactorSetupArgs = {
  code: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


export type MutationVerifyTwoFactorSetupArgs = {
  code: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export type OfflineManifest = {
  __typename?: 'OfflineManifest';
  files: Array<OfflineManifestFile>;
  /** layerId -> updatedAt ISO string, for client staleness tracking */
  layerVersions: Scalars['JSON']['output'];
  projectId: Scalars['ID']['output'];
  totalBytes: Scalars['Float']['output'];
};

export type OfflineManifestFile = {
  __typename?: 'OfflineManifestFile';
  kind: LayerType;
  layerId: Scalars['ID']['output'];
  sizeBytes: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};

export type OnboardingInviteInput = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Organization = {
  __typename?: 'Organization';
  authBrandingEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  customDomain?: Maybe<OrganizationCustomDomain>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  ephemeralBytes: Scalars['Long']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<Attachment>;
  logoId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  projects?: Maybe<Array<Project>>;
  role?: Maybe<UserOrganizationRole>;
  slug?: Maybe<Scalars['String']['output']>;
  storageLimitBytes: Scalars['Long']['output'];
  storageUsedBytes: Scalars['Long']['output'];
  subscription: SubscriptionInfo;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationCustomDomain = {
  __typename?: 'OrganizationCustomDomain';
  cnameTarget: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dnsVerified: Scalars['Boolean']['output'];
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: CustomDomainStatus;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlanPrice = {
  __typename?: 'PlanPrice';
  annualAmount: Scalars['Int']['output'];
  monthlyAmount: Scalars['Int']['output'];
  plan: SubscriptionPlan;
};

export type PointCloudClassSettings = {
  __typename?: 'PointCloudClassSettings';
  color: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
};

export type PointCloudClassSettingsInput = {
  color: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
};

export enum PointCloudPointSizeType {
  Adaptive = 'ADAPTIVE',
  Fixed = 'FIXED'
}

export enum PointColorType {
  Clearance = 'CLEARANCE',
  Grayscale = 'GRAYSCALE',
  Inferno = 'INFERNO',
  Plasma = 'PLASMA',
  Rainbow = 'RAINBOW',
  Rgb = 'RGB',
  Spectral = 'SPECTRAL',
  Viridis = 'VIRIDIS',
  YellowGreen = 'YELLOW_GREEN'
}

export type PricingInfo = {
  __typename?: 'PricingInfo';
  currency: Scalars['String']['output'];
  plans: Array<PlanPrice>;
};

export type ProcessJob = {
  __typename?: 'ProcessJob';
  attempts: Scalars['Int']['output'];
  batchId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  errorLogs?: Maybe<Scalars['String']['output']>;
  estimatedCompletion?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inputJson: Scalars['JSON']['output'];
  isLeaf: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  leaseUntil?: Maybe<Scalars['DateTime']['output']>;
  logStream?: Maybe<Scalars['String']['output']>;
  logs?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  outputJson?: Maybe<Scalars['JSON']['output']>;
  parentItemId?: Maybe<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ProcessJobStatus;
  type: ProcessJobType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ProcessJobStatus {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Waiting = 'WAITING'
}

export enum ProcessJobType {
  ChcImage = 'CHC_IMAGE',
  Clearance = 'CLEARANCE',
  ClipboxExport = 'CLIPBOX_EXPORT',
  Decimated = 'DECIMATED',
  Deviation = 'DEVIATION',
  DjiImage = 'DJI_IMAGE',
  Dwg = 'DWG',
  Dxf = 'DXF',
  E57 = 'E57',
  FjdImage = 'FJD_IMAGE',
  Geojson = 'GEOJSON',
  Geotiff = 'GEOTIFF',
  Gpkg = 'GPKG',
  GroundClassify = 'GROUND_CLASSIFY',
  Ifc = 'IFC',
  IfcFragment = 'IFC_FRAGMENT',
  Image = 'IMAGE',
  ImageCompression = 'IMAGE_COMPRESSION',
  Iprj = 'IPRJ',
  Jp2 = 'JP2',
  Kml = 'KML',
  Landxml = 'LANDXML',
  LandxmlExport = 'LANDXML_EXPORT',
  Las = 'LAS',
  LayerStack = 'LAYER_STACK',
  LeicaImage = 'LEICA_IMAGE',
  Mesh = 'MESH',
  MosaicImage = 'MOSAIC_IMAGE',
  OmnislamImage = 'OMNISLAM_IMAGE',
  PdfReport = 'PDF_REPORT',
  Post = 'POST',
  Potree = 'POTREE',
  Privacy = 'PRIVACY',
  Pts = 'PTS',
  RainfallAnalysis = 'RAINFALL_ANALYSIS',
  Rcs = 'RCS',
  Render = 'RENDER',
  SectionOverlays = 'SECTION_OVERLAYS',
  Shp = 'SHP',
  SouthImage = 'SOUTH_IMAGE',
  Splat = 'SPLAT',
  SurfaceDifference = 'SURFACE_DIFFERENCE',
  TopconImage = 'TOPCON_IMAGE',
  TrimbleImage = 'TRIMBLE_IMAGE',
  VectorExport = 'VECTOR_EXPORT',
  Wms = 'WMS',
  Xgrids = 'XGRIDS'
}

export enum ProductLine {
  Pro = 'PRO',
  Viewer = 'VIEWER'
}

export type Project = {
  __typename?: 'Project';
  archiveBytes?: Maybe<Scalars['Long']['output']>;
  archiveError?: Maybe<Scalars['String']['output']>;
  archiveNonArchivedBytes?: Maybe<Scalars['Long']['output']>;
  archiveRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  archiveStatus: ArchiveStatus;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  baseMaps: Array<CustomBaseMap>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['ID']['output'];
  defaultThirdPersonView: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ephemeralBytes: Scalars['Long']['output'];
  folder?: Maybe<ProjectFolder>;
  folderId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  initialAngle: Scalars['Int']['output'];
  initialPosition?: Maybe<Scalars['GeometryZ']['output']>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  proj4String?: Maybe<Scalars['String']['output']>;
  restoreExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  restoreRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  restoreRetrievedAt?: Maybe<Scalars['DateTime']['output']>;
  retentionUntil?: Maybe<Scalars['DateTime']['output']>;
  srid: Scalars['Int']['output'];
  storageUsedBytes: Scalars['Long']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID']['output'];
};

export type ProjectByLinks = {
  __typename?: 'ProjectByLinks';
  linkCount: Scalars['Int']['output'];
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
};

export type ProjectFolder = {
  __typename?: 'ProjectFolder';
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectLink = {
  __typename?: 'ProjectLink';
  allowQuickUploads: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  ephemeralBytes: Scalars['Long']['output'];
  expiresAt: Scalars['DateTime']['output'];
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  projectId: Scalars['ID']['output'];
  status: ProjectLinkStatus;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewCount: Scalars['Int']['output'];
};

export enum ProjectLinkStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Expired = 'EXPIRED'
}

export type PromoCodeValidation = {
  __typename?: 'PromoCodeValidation';
  amountOff?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Float']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type PropertyAlias = {
  __typename?: 'PropertyAlias';
  alias: Scalars['String']['output'];
  property: Scalars['String']['output'];
};

export type PropertyAliasInput = {
  alias: Scalars['String']['input'];
  property: Scalars['String']['input'];
};

export type PropertyValues = {
  __typename?: 'PropertyValues';
  property: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  allProjectLinks: Array<ProjectLink>;
  archivePreview: ArchivePreview;
  archivedProjects: Array<Project>;
  attachments: Array<Attachment>;
  attachmentsByBatch: Array<Attachment>;
  batch: UploadBatch;
  batches: Array<UploadBatch>;
  clearanceProfiles: Array<ClearanceProfile>;
  customDomainStatus?: Maybe<OrganizationCustomDomain>;
  dashboardStats: DashboardStats;
  deviationJobs: Array<ProcessJob>;
  feature: Feature;
  featureAttachment: FeatureAttachment;
  featureAttachments: Array<FeatureAttachment>;
  featureSummary: FeatureSummary;
  features: Array<Feature>;
  featuresByIds: Array<Feature>;
  featuresByLayer: Array<Feature>;
  featuresPaginated: FeaturePaginated;
  googleImage: GoogleImage;
  googleImageByPanoId: GoogleImage;
  googleImagesByPosition: Array<GoogleImage>;
  image: Image;
  images: Array<Image>;
  imagesByLayer: Array<Image>;
  invitations: Array<UserInvitation>;
  jobs: Array<ProcessJob>;
  jobsByBatch: Array<ProcessJob>;
  layer: Layer;
  layerByproducts: Array<Byproduct>;
  layerProperties: Array<Scalars['String']['output']>;
  layerPropertyValues: Array<PropertyValues>;
  layers: Array<Layer>;
  layersNested: Array<Layer>;
  me: User;
  myReferrals: Array<Referral>;
  organization: Organization;
  organizations: Array<Organization>;
  project: Project;
  projectFolders: Array<ProjectFolder>;
  projectLinkViews: Array<LinkView>;
  projectLinks: Array<ProjectLink>;
  projectOfflineManifest: OfflineManifest;
  projects: Array<Project>;
  savedViews: Array<SavedView>;
  searchProjects: Array<SearchProjectResult>;
  /** Returns the current share link when the request is authorised via one, else null. */
  sharedLink?: Maybe<ProjectLink>;
  sharedLinkDashboard: SharedLinkDashboard;
  sharedProject: Project;
  slugAvailable: Scalars['Boolean']['output'];
  srids: Array<Srid>;
  subscriptionDetails: SubscriptionDetails;
  subscriptionPaymentUrl?: Maybe<Scalars['String']['output']>;
  subscriptionPricing: PricingInfo;
  surfaceDifferenceJobs: Array<ProcessJob>;
  user: User;
  userPasskeys: Array<UserPasskey>;
  userSessions: Array<UserSession>;
  users: Array<User>;
  validatePromoCode: PromoCodeValidation;
};


export type QueryArchivePreviewArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryAttachmentsByBatchArgs = {
  batchId: Scalars['ID']['input'];
};


export type QueryBatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBatchesArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryDeviationJobsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryFeatureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeatureAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeatureAttachmentsArgs = {
  featureId: Scalars['ID']['input'];
};


export type QueryFeatureSummaryArgs = {
  filters?: InputMaybe<Array<FeatureFilter>>;
  layerId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeaturesArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryFeaturesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryFeaturesByLayerArgs = {
  layerIds: Array<Scalars['ID']['input']>;
};


export type QueryFeaturesPaginatedArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FeatureFilter>>;
  layerId?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<FeatureOrder>;
  projectId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGoogleImageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGoogleImageByPanoIdArgs = {
  panoId: Scalars['String']['input'];
};


export type QueryGoogleImagesByPositionArgs = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};


export type QueryImageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImagesArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryImagesByLayerArgs = {
  layerIds: Array<Scalars['ID']['input']>;
};


export type QueryJobsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryJobsByBatchArgs = {
  batchId: Scalars['ID']['input'];
};


export type QueryLayerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLayerByproductsArgs = {
  layerId: Scalars['ID']['input'];
};


export type QueryLayerPropertiesArgs = {
  layerId: Scalars['ID']['input'];
};


export type QueryLayerPropertyValuesArgs = {
  layerId: Scalars['ID']['input'];
};


export type QueryLayersArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryLayersNestedArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectLinkViewsArgs = {
  linkId: Scalars['ID']['input'];
};


export type QueryProjectLinksArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectOfflineManifestArgs = {
  projectId: Scalars['ID']['input'];
};


export type QuerySavedViewsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QuerySearchProjectsArgs = {
  query: Scalars['String']['input'];
};


export type QuerySlugAvailableArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySubscriptionDetailsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QuerySubscriptionPaymentUrlArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QuerySurfaceDifferenceJobsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserSessionsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryValidatePromoCodeArgs = {
  code: Scalars['String']['input'];
};

export type QuickUploadLayerInput = {
  contentBase64: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  sessionId: Scalars['String']['input'];
};

export type QuickUploadLayerResult = {
  __typename?: 'QuickUploadLayerResult';
  expiresAt: Scalars['DateTime']['output'];
  layer: Layer;
};

export type RainfallAnalysisParams = {
  /** Minimum pond surface area (m²) to keep in the output. */
  minPondAreaM2: Scalars['Float']['input'];
  /** Minimum pond depth (m) to keep — filters survey-noise pits. */
  minPondDepthM: Scalars['Float']['input'];
  /**
   * Analysis mode. TOPOLOGY (default) only computes flow direction +
   * upstream area. STORM additionally accepts a design storm (depth,
   * duration, runoff coefficient) and produces peak runoff per flow
   * line and pond fill times.
   */
  mode: RainfallMode;
  /** DEM cell size in metres. Range [0.05, 5.0]. */
  resolutionM: Scalars['Float']['input'];
  /**
   * Required when mode = STORM. Dimensionless runoff coefficient C
   * applied uniformly across the survey. Typical values: 0.85 asphalt,
   * 0.95 roofs, 0.30 grass, 0.85 concrete.
   */
  runoffCoefficient?: InputMaybe<Scalars['Float']['input']>;
  /** How depressions are routed for flow lines. Pond detection is invariant to this. */
  sinkHandling: SinkHandling;
  /** Required when mode = STORM. Storm depth in millimetres. */
  stormDepthMm?: InputMaybe<Scalars['Float']['input']>;
  /** Required when mode = STORM. Storm duration in hours. */
  stormDurationH?: InputMaybe<Scalars['Float']['input']>;
};

export enum RainfallMode {
  Storm = 'STORM',
  Topology = 'TOPOLOGY'
}

export type Referral = {
  __typename?: 'Referral';
  accountCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  organizationCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  referredEmail: Scalars['String']['output'];
  referredUser?: Maybe<User>;
  subscriptionStartedAt?: Maybe<Scalars['DateTime']['output']>;
  token: Scalars['String']['output'];
};

export type ReportOptionsInput = {
  generate: Scalars['Boolean']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportSectionInput = {
  deviation?: InputMaybe<DeviationSectionInput>;
  layerStack?: InputMaybe<LayerStackSectionInput>;
  stationPages?: InputMaybe<StationPagesSectionInput>;
  stationVolumes?: InputMaybe<StationVolumeSectionInput>;
  type: ReportSectionType;
};

export enum ReportSectionType {
  Deviation = 'DEVIATION',
  LayerStack = 'LAYER_STACK',
  StationPages = 'STATION_PAGES',
  StationVolumes = 'STATION_VOLUMES',
  Stockpile = 'STOCKPILE'
}

export type S3CompletedPart = {
  ChecksumSHA256: Scalars['String']['input'];
  ETag: Scalars['String']['input'];
  PartNumber: Scalars['Int']['input'];
};

export type Srid = {
  __typename?: 'SRID';
  name: Scalars['String']['output'];
  projection: Scalars['String']['output'];
  srid: Scalars['Int']['output'];
};

export type SaveClearanceProfileInput = {
  /** Omit to create; supply to update an existing profile in this organization. */
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  /** Carried through from a shipped preset when the user saves a copy. Max 300 characters. */
  sourceAttribution?: InputMaybe<Scalars['String']['input']>;
  /** 3 – 64 vertices, |offset| <= 100 m, finite, non-self-intersecting, non-zero area. */
  vertices: Array<Array<Scalars['Float']['input']>>;
};

export type SavedView = {
  __typename?: 'SavedView';
  baseMapId?: Maybe<Scalars['ID']['output']>;
  camera: Scalars['JSON']['output'];
  clipBox: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visibility: SavedViewVisibility;
  visibleLayerIds: Array<Scalars['ID']['output']>;
};

export enum SavedViewVisibility {
  Private = 'PRIVATE',
  Shared = 'SHARED'
}

export type SearchProjectResult = {
  __typename?: 'SearchProjectResult';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  organizationSlug: Scalars['String']['output'];
};

export enum SectionOverlayKind {
  LayerSurface = 'LAYER_SURFACE',
  RunSections = 'RUN_SECTIONS'
}

export type SectionOverlaySetting = {
  __typename?: 'SectionOverlaySetting';
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  kind: SectionOverlayKind;
  layerId: Scalars['ID']['output'];
  pcMethod?: Maybe<Scalars['String']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
};

export type SectionOverlaySettingInput = {
  hidden: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  kind: SectionOverlayKind;
  layerId: Scalars['ID']['input'];
  pcMethod?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type SetupAuthenticatorResult = {
  __typename?: 'SetupAuthenticatorResult';
  otpauthUri: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type SetupTwoFactorResult = {
  __typename?: 'SetupTwoFactorResult';
  secret: Scalars['String']['output'];
};

export type SharedLinkDashboard = {
  __typename?: 'SharedLinkDashboard';
  dailyViews: Array<DailyViews>;
  topLinksByViews: Array<LinkWithViews>;
  topProjectsByLinks: Array<ProjectByLinks>;
  totalLinks: Scalars['Int']['output'];
};

export enum SinkHandling {
  Breach = 'BREACH',
  Fill = 'FILL'
}

export type StartClearanceInput = {
  /** Client-side snapshot of a registry alignment — the same type station volumes uses. */
  alignment: AlignmentInput;
  /** Optional output-layer name. Max 120 characters. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The one POINTCLOUD layer to classify. */
  pointcloudLayerId: Scalars['ID']['input'];
  profile: ClearanceProfileSnapshotInput;
  projectId: Scalars['ID']['input'];
  /** Internal stations. Omit for the whole alignment. */
  stationFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Bin length in metres. 1 – 500, default 20. */
  stationInterval?: InputMaybe<Scalars['Float']['input']>;
  stationTo?: InputMaybe<Scalars['Float']['input']>;
  /** Metres added to the alignment Z before the profile's heights are measured. Default 0. */
  verticalOffsetM?: InputMaybe<Scalars['Float']['input']>;
};

export type StartClipboxExportInput = {
  clipBox: ClipBoxInput;
  format: ClipboxExportFormat;
  /** Optional human label; defaults to '<sourceLayer> (clipped)'. */
  label?: InputMaybe<Scalars['String']['input']>;
  sourceLayerId: Scalars['ID']['input'];
};

export type StartDeviationAnalysisInput = {
  /**
   * Optional VECTOR layer whose polygons / closed polylines bound the analysis.
   * Only source points inside its 2D footprint are processed.
   */
  boundaryLayerId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional conformance check. Absent = today's behaviour. */
  expectation?: InputMaybe<SurfaceExpectationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  params: DeviationParamsInput;
  referenceLayerId: Scalars['ID']['input'];
  reportOptions?: InputMaybe<ReportOptionsInput>;
  sourceLayerId: Scalars['ID']['input'];
  /**
   * Optional alignment-based station breakdown (spec §10.1) — the same input the
   * surface-difference mutation takes. Requires params.volumeStats: true and
   * params.volumePlane unset or "xy": the breakdown is a second pass over the
   * volume integration's in-range points, so without the volume grid there is
   * nothing to bin. Absent = today's behaviour.
   */
  stationVolumes?: InputMaybe<StationVolumeInput>;
};

export type StartGroundClassificationInput = {
  /**
   * Optional VECTOR layer whose polygons / closed polylines bound the analysis.
   * Only source points inside its 2D footprint are processed.
   */
  boundaryLayerId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  params: GroundClassifyParamsInput;
  sourceLayerId: Scalars['ID']['input'];
};

/**
 * Export the top surfaces of selected IFC elements as a LandXML 1.2 TIN.
 * One <Surface> per element (or one per group when merging). Result is a
 * LANDXML byproduct and a new MODEL / LANDXML layer next to the source layer —
 * one of each per group when 'groups' is given.
 */
export type StartLandxmlExportInput = {
  /**
   * Split the export into one file / layer per named group. Null or empty ⇒ a
   * single export driven by 'guids'.
   */
  groups?: InputMaybe<Array<LandxmlExportGroupInput>>;
  /**
   * Optional IfcGloballyUniqueId subset (from the IFC tree). Null ⇒ no GUID filter.
   * Ignored when 'groups' is given.
   */
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Optional IFC class filter, e.g. ["IfcSlab", "IfcRoof"]. Null ⇒ every
   * represented product except openings / spaces / annotations / grids.
   */
  ifcTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Source MODEL layer (metadata.type FRAGMENT or IFC). */
  layerId: Scalars['ID']['input'];
  /**
   * Weld each export into a SINGLE surface (topmost face wins where elements
   * overlap in plan) instead of one surface per element. Defaults to false.
   */
  merge?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Output / layer name; defaults to "<layer name> surfaces". With 'groups' it
   * is the prefix: each layer is named "<name> — <group name>".
   */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Start a multi-layer thickness analysis (LAYER_STACK). N levels (top of
 * wearing course, …, formation) give N-1 layers of material between them —
 * see `docs` for the level/layer terminology. Every level needs a design
 * surface, an as-built surface, or both; a level with only a design is
 * PENDING (not yet built), the normal state of a part-built pavement.
 */
export type StartLayerStackInput = {
  /** Top to bottom. At least two levels (one layer) are required. */
  levels: Array<LayerStackLevelInput>;
  /** Optional output-layer / batch-label name. */
  name?: InputMaybe<Scalars['String']['input']>;
  params: LayerStackParamsInput;
  /** Optional: opt into generating a PDF report when the analysis finishes. */
  reportOptions?: InputMaybe<ReportOptionsInput>;
  /** Optional alignment-based station breakdown. Absent = today's behaviour. */
  stationVolumes?: InputMaybe<StationVolumeInput>;
};

export type StartMeshExportInput = {
  algorithm: MeshAlgorithm;
  /** Optional clip-box restriction. Uses existing ClipBoxInput type. */
  clipBox?: InputMaybe<ClipBoxInput>;
  /** Optional custom output name. */
  name?: InputMaybe<Scalars['String']['input']>;
  outputFormat: MeshOutputFormat;
  /** Algorithm-specific parameters. */
  params: Scalars['JSON']['input'];
  sourceLayerId: Scalars['ID']['input'];
};

export type StartPdfReportInput = {
  locale: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  sections: Array<ReportSectionInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StartRainfallAnalysisInput = {
  /** Optional human label; defaults to '<sourceLayerName> rainfall'. */
  label?: InputMaybe<Scalars['String']['input']>;
  params: RainfallAnalysisParams;
  /** Source VECTOR layer holding a TIN (3D triangle features). */
  sourceLayerId: Scalars['ID']['input'];
};

export type StartSurfaceDifferenceInput = {
  /** Bottom / design surface. */
  bottom: SurfaceInput;
  /**
   * Optional VECTOR layer whose polygons / closed polylines bound the analysis.
   * Only source points inside its 2D footprint are processed.
   */
  boundaryLayerId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional conformance check. Absent = today's behaviour. */
  expectation?: InputMaybe<SurfaceExpectationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  params: SurfaceDifferenceParamsInput;
  /**
   * Optional: opt into generating a PDF report when the analysis finishes
   * (spec §10.6). The worker chains a PDF_REPORT job containing the
   * STATION_VOLUMES section, so this only produces a document when
   * stationVolumes is set too — there is no surface-difference report
   * section yet. title/notes/locale customise the report.
   */
  reportOptions?: InputMaybe<ReportOptionsInput>;
  /** Optional alignment-based station breakdown. Absent = today's behaviour. */
  stationVolumes?: InputMaybe<StationVolumeInput>;
  /** Top / existing surface. dz = top - bottom; dz > 0 is fill, dz < 0 is cut. */
  top: SurfaceInput;
};

export type StartVectorExportInput = {
  crs: ExportCrs;
  /** Optional explicit feature subset. When omitted, every feature in layerId is exported. */
  featureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  format: VectorExportFormat;
  /** Optional human label; defaults to the layer name. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Source VECTOR layer. Required even when exporting a feature selection — used for auth, naming, and byproduct grouping. */
  layerId: Scalars['ID']['input'];
};

/**
 * One A4-landscape page per station bin (spec §13). Its own document: it
 * cannot share a report with any other section.
 */
export type StationPagesSectionInput = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The derived analysis layer carrying metadata.stationVolumes, or a
   * LAYER_STACK result layer carrying metadata.layerStack (see stackLayerIndex).
   */
  layerId: Scalars['ID']['input'];
  /**
   * Optional export-only colormap for station renders. Omitted means use the
   * deviation run's renderColormap/colormap.
   */
  renderColormap?: InputMaybe<Scalars['String']['input']>;
  renderRangeMax?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Optional export-only deviation color range for station renders. When both
   * values are supplied, the render job maps colors and prints the colorbar over
   * this range instead of the analysis run's original range. Ignored unless
   * renders is true.
   */
  renderRangeMin?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Render a top-down view of the coloured deviation cloud for every station
   * page (spec §13.7). Deviation runs only, and only when the analysis
   * registered a station_bins.geojson byproduct — otherwise the request is
   * accepted and the document simply prints without renders. Queues a RENDER
   * child job that chains the PDF when it finishes, so the report takes roughly
   * a second per page longer. Default: false.
   */
  renders?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * LAYER_STACK results only, and REQUIRED for them: which of the stack's N-1
   * layers to print. A stack has one bin array per layer, each with its own
   * volumes and its own verdict, so there is no honest default. The pages draw
   * the whole stacked cross-section either way (spec §7); this chooses whose
   * volumes go in the table. Ignored for a single-pair analysis.
   */
  stackLayerIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Internal stations; omit for the whole analysis. */
  stationFrom?: InputMaybe<Scalars['Float']['input']>;
  stationTo?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Optional station breakdown of a volume analysis. Binning is on INTERNAL
 * station; stationFrom/stationTo are internal too (the client converts display
 * stations with displayToInternal before sending).
 */
export type StationVolumeInput = {
  alignment: AlignmentInput;
  /** Optional crossfall / superelevation check over one or two lane bands. */
  crossfall?: InputMaybe<CrossfallInput>;
  /** Bins below this coverage are flagged, not dropped. 0 – 100, default 60. */
  minCoveragePct?: InputMaybe<Scalars['Float']['input']>;
  /** Offset bin width for the section array. 0.1 – 5, default 0.5. */
  offsetBin?: InputMaybe<Scalars['Float']['input']>;
  /** Internal stations. Omit for the full alignment. */
  stationFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Bin length in metres. 1 – 500, default 20. */
  stationInterval: Scalars['Float']['input'];
  stationTo?: InputMaybe<Scalars['Float']['input']>;
  /** Metres left of the centreline (offset < 0). 0 – 500. */
  swathLeft: Scalars['Float']['input'];
  /** Metres right of the centreline (offset > 0). 0 – 500. */
  swathRight: Scalars['Float']['input'];
};

export type StationVolumeSectionInput = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
  /** The derived GLB layer carrying metadata.surfaceDifference.stationVolumes. */
  layerId: Scalars['ID']['input'];
  /** Internal stations; omit for the whole analysis. */
  stationFrom?: InputMaybe<Scalars['Float']['input']>;
  stationTo?: InputMaybe<Scalars['Float']['input']>;
};

export type SubscriptionDetails = {
  __typename?: 'SubscriptionDetails';
  discount?: Maybe<DiscountInfo>;
  info: SubscriptionInfo;
  invoices: Array<Invoice>;
  nextInvoicePreview?: Maybe<InvoicePreview>;
};

export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  billingInterval?: Maybe<BillingInterval>;
  billingStatus: BillingStatus;
  cancelAt?: Maybe<Scalars['DateTime']['output']>;
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  collectionMethod?: Maybe<CollectionMethod>;
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  isCustom: Scalars['Boolean']['output'];
  maxSeats: Scalars['Int']['output'];
  plan: SubscriptionPlan;
  productLine: ProductLine;
  scheduledChangeAt?: Maybe<Scalars['DateTime']['output']>;
  scheduledPlan?: Maybe<SubscriptionPlan>;
  seatsUsed: Scalars['Int']['output'];
  storageLimitBytes: Scalars['Long']['output'];
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum SubscriptionPlan {
  Business = 'BUSINESS',
  Custom = 'CUSTOM',
  Free = 'FREE',
  Starter = 'STARTER',
  Team = 'TEAM'
}

export enum SubscriptionTier {
  Core = 'CORE',
  Enterprise = 'ENTERPRISE',
  Free = 'FREE',
  Lite = 'LITE',
  Plus = 'PLUS'
}

export type SurfaceDifferenceParamsInput = {
  boundaryGeojson?: InputMaybe<Scalars['JSON']['input']>;
  colormap?: InputMaybe<Scalars['String']['input']>;
  exportDxf?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Also write the difference GeoTIFFs (dz + RGB) and tile the RGB one into a
   * companion raster layer. Omitted = true, as every run before the field.
   */
  exportTif?: InputMaybe<Scalars['Boolean']['input']>;
  fillHoles?: InputMaybe<Scalars['Int']['input']>;
  rangeMax?: InputMaybe<Scalars['Float']['input']>;
  rangeMin?: InputMaybe<Scalars['Float']['input']>;
  resolution: Scalars['Float']['input'];
};

export type SurfaceExpectationInput = {
  /** Fail above this share of MEASURED area out of tolerance. Default 5. */
  failAreaPct?: InputMaybe<Scalars['Float']['input']>;
  lower?: InputMaybe<SurfaceInput>;
  mode: SurfaceExpectationMode;
  overToleranceM?: InputMaybe<Scalars['Float']['input']>;
  /** CONSTANT only. METRES, positive. The UI collects millimetres. */
  thicknessM?: InputMaybe<Scalars['Float']['input']>;
  /** Metres, >= 0. Omitted = that side is measured but never fails. */
  underToleranceM?: InputMaybe<Scalars['Float']['input']>;
  /** SURFACES only. Their own difference becomes the expected value. */
  upper?: InputMaybe<SurfaceInput>;
};

/** What the difference between two surfaces is expected to be. */
export enum SurfaceExpectationMode {
  /** A set thickness, in metres. */
  Constant = 'CONSTANT',
  /** The two surfaces should coincide. Level conformance, settlement. */
  Match = 'MATCH',
  /** No expectation — measure the volume. Today's behaviour. */
  None = 'NONE',
  /** The gap between two other surfaces, cell by cell. */
  Surfaces = 'SURFACES'
}

/**
 * One side of a surface-difference analysis. The layer may be a POINTCLOUD
 * (LAZ, gridded with pcMethod), a MODEL (LandXML / DXF / IFC) or a VECTOR
 * (GeoJSON PolygonZ). surfaceIds restricts multi-surface LandXML / GeoJSON
 * inputs to the named surfaces.
 */
export type SurfaceInput = {
  layerId: Scalars['ID']['input'];
  pcMethod?: InputMaybe<Scalars['String']['input']>;
  surfaceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ThemePreference {
  Dark = 'DARK',
  Light = 'LIGHT',
  System = 'SYSTEM'
}

export enum TwoFactorType {
  Authenticator = 'AUTHENTICATOR',
  Sms = 'SMS'
}

export type UpdateFeatureAttachmentInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeatureInput = {
  geometry?: InputMaybe<Scalars['GeometryZ']['input']>;
  geometryWGS84?: InputMaybe<Scalars['GeometryZ']['input']>;
  id: Scalars['ID']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateImageInput = {
  id: Scalars['ID']['input'];
  layerId?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['Geometry']['input']>;
  locationWGS84?: InputMaybe<Scalars['Geometry']['input']>;
};

export type UpdateLayerInput = {
  bbox?: InputMaybe<Scalars['Geometry']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentLayerId?: InputMaybe<Scalars['ID']['input']>;
  propertyAliases?: InputMaybe<Array<PropertyAliasInput>>;
  type?: InputMaybe<LayerType>;
};

export type UpdateLayerSettingsBatchInput = {
  id: Scalars['ID']['input'];
  settings: LayerSettingsInput;
};

export type UpdateOrganizationInput = {
  authBrandingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type UpdateProjectInput = {
  defaultThirdPersonView?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  initialAngle?: InputMaybe<Scalars['Int']['input']>;
  initialPosition?: InputMaybe<Scalars['GeometryZ']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSavedViewInput = {
  baseMapId?: InputMaybe<Scalars['ID']['input']>;
  camera?: InputMaybe<Scalars['JSON']['input']>;
  clipBox?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<SavedViewVisibility>;
  visibleLayerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateUserInput = {
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UploadBatch = {
  __typename?: 'UploadBatch';
  attachments: Array<Attachment>;
  /**
   * Byproducts produced by jobs in this batch. Used by ANALYSIS batches
   * (deviation, ground-classify, clipbox export) which have no attachments
   * but produce downloadable outputs.
   */
  byproducts: Array<Byproduct>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  jobs: Array<ProcessJob>;
  key: Scalars['String']['output'];
  kind: UploadBatchKind;
  label?: Maybe<Scalars['String']['output']>;
  numberOfAttachments: Scalars['Int']['output'];
  processingCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  processingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  srid: Scalars['Int']['output'];
  status: UploadBatchStatus;
  /** Total bytes this batch contributes to org quota (attachments + byproducts). */
  totalBytes: Scalars['Long']['output'];
};

export enum UploadBatchKind {
  Analysis = 'ANALYSIS',
  Upload = 'UPLOAD'
}

export enum UploadBatchStatus {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Uploading = 'UPLOADING',
  Waiting = 'WAITING'
}

export enum UploadType {
  FeatureAttachment = 'FEATURE_ATTACHMENT',
  OrganizationLogo = 'ORGANIZATION_LOGO',
  UserAvatar = 'USER_AVATAR'
}

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Attachment>;
  avatarId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  featurebaseUser?: Maybe<FeaturebaseUser>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isReferrer: Scalars['Boolean']['output'];
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  mobileNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  onboardingSurveyCompleted: Scalars['Boolean']['output'];
  onboardingTourCompleted: Scalars['Boolean']['output'];
  role?: Maybe<UserOrganizationRole>;
  theme: ThemePreference;
  twoFactorEnabled: Scalars['Boolean']['output'];
  twoFactorType?: Maybe<TwoFactorType>;
  updatedAt: Scalars['DateTime']['output'];
  viewerSettings: UserViewerSettings;
};

export type UserInvitation = {
  __typename?: 'UserInvitation';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  role: UserOrganizationRole;
};

export type UserInvitationResult = {
  __typename?: 'UserInvitationResult';
  error?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  success: Scalars['Boolean']['output'];
};

export enum UserOrganizationRole {
  Admin = 'ADMIN',
  BillingManager = 'BILLING_MANAGER',
  Editor = 'EDITOR',
  Member = 'MEMBER'
}

export type UserPasskey = {
  __typename?: 'UserPasskey';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type UserSession = {
  __typename?: 'UserSession';
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  ipHash: Scalars['String']['output'];
  lastUsedAt: Scalars['DateTime']['output'];
  loginMethod: UserSessionMethod;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  status: UserSessionStatus;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export enum UserSessionMethod {
  Otp = 'OTP',
  Password = 'PASSWORD'
}

export enum UserSessionStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

export type UserViewerSettings = {
  __typename?: 'UserViewerSettings';
  actionPosition: ActionPosition;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  customBaseMaps?: Maybe<Array<CustomBaseMap>>;
  googleStreetViewPoiColor?: Maybe<Scalars['String']['output']>;
  imagePOIMaxDistance: Scalars['Int']['output'];
  orthoPointSize: Scalars['Float']['output'];
  pointCloudLoadingDistance: Scalars['Int']['output'];
  pointCloudMinNodePixelSize: Scalars['Int']['output'];
  pointCloudPointBudget: Scalars['Int']['output'];
  pointCloudPointSize: Scalars['Float']['output'];
  pointCloudPointSizeType: PointCloudPointSizeType;
  showAllImagePOIs: Scalars['Boolean']['output'];
  showImagePOIs: Scalars['Boolean']['output'];
  showLayerSource: Scalars['Boolean']['output'];
  showLayerUnderType: Scalars['Boolean']['output'];
  showOrthoGrid: Scalars['Boolean']['output'];
  showPointCloudBoundingBoxes: Scalars['Boolean']['output'];
};

export enum VectorExportFormat {
  Dwg = 'DWG',
  Dxf = 'DXF',
  Gpkg = 'GPKG',
  Shp = 'SHP'
}

export type ViewerSettingsInput = {
  actionPosition?: InputMaybe<ActionPosition>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  customBaseMaps?: InputMaybe<Array<CustomBaseMapInput>>;
  googleStreetViewPoiColor?: InputMaybe<Scalars['String']['input']>;
  imagePOIMaxDistance?: InputMaybe<Scalars['Int']['input']>;
  orthoPointSize?: InputMaybe<Scalars['Float']['input']>;
  pointCloudLoadingDistance?: InputMaybe<Scalars['Int']['input']>;
  pointCloudMinNodePixelSize?: InputMaybe<Scalars['Int']['input']>;
  pointCloudPointBudget: Scalars['Int']['input'];
  pointCloudPointSize: Scalars['Float']['input'];
  pointCloudPointSizeType: PointCloudPointSizeType;
  showAllImagePOIs?: InputMaybe<Scalars['Boolean']['input']>;
  showImagePOIs: Scalars['Boolean']['input'];
  showLayerSource: Scalars['Boolean']['input'];
  showLayerUnderType: Scalars['Boolean']['input'];
  showOrthoGrid?: InputMaybe<Scalars['Boolean']['input']>;
  showPointCloudBoundingBoxes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, name: string, description?: string | null, srid: number, defaultThirdPersonView: boolean } };

export type CreateProjectLinkMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  expiresAt: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  allowQuickUploads?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateProjectLinkMutation = { __typename?: 'Mutation', createProjectLink: { __typename?: 'ProjectLink', id: string, projectId: string, token: string, hasPassword: boolean, expiresAt: Date, createdAt: Date, createdById: string, allowQuickUploads: boolean, createdBy?: { __typename?: 'User', id: string, name: string, email: string } | null } };

export type UpdateProjectLinkPasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectLinkPasswordMutation = { __typename?: 'Mutation', updateProjectLinkPassword: { __typename?: 'ProjectLink', id: string, hasPassword: boolean } };

export type UpdateProjectLinkAllowQuickUploadsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  allowQuickUploads: Scalars['Boolean']['input'];
}>;


export type UpdateProjectLinkAllowQuickUploadsMutation = { __typename?: 'Mutation', updateProjectLinkAllowQuickUploads: { __typename?: 'ProjectLink', id: string, allowQuickUploads: boolean } };

export type DeleteProjectLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectLinkMutation = { __typename?: 'Mutation', deleteProjectLink: boolean };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: boolean };

export type ArchiveProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveProjectMutation = { __typename?: 'Mutation', archiveProject: { __typename?: 'Project', id: string, archiveStatus: ArchiveStatus, archiveRequestedAt?: Date | null } };

export type RestoreProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreProjectMutation = { __typename?: 'Mutation', restoreProject: { __typename?: 'Project', id: string, archiveStatus: ArchiveStatus, restoreRequestedAt?: Date | null, restoreExpiresAt?: Date | null } };

export type DeleteArchivedProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteArchivedProjectMutation = { __typename?: 'Mutation', deleteArchivedProject: boolean };

export type AddProjectBaseMapMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  input: CustomBaseMapInput;
}>;


export type AddProjectBaseMapMutation = { __typename?: 'Mutation', addProjectBaseMap: { __typename?: 'Project', id: string, baseMaps: Array<{ __typename?: 'CustomBaseMap', id: string, name: string, type: string, url: string, tileSize?: number | null, wmsVersion?: string | null, wmsLayers?: string | null, format?: string | null }> } };

export type UpdateProjectBaseMapMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  baseMapId: Scalars['ID']['input'];
  input: CustomBaseMapInput;
}>;


export type UpdateProjectBaseMapMutation = { __typename?: 'Mutation', updateProjectBaseMap: { __typename?: 'Project', id: string, baseMaps: Array<{ __typename?: 'CustomBaseMap', id: string, name: string, type: string, url: string, tileSize?: number | null, wmsVersion?: string | null, wmsLayers?: string | null, format?: string | null }> } };

export type DeleteProjectBaseMapMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  baseMapId: Scalars['ID']['input'];
}>;


export type DeleteProjectBaseMapMutation = { __typename?: 'Mutation', deleteProjectBaseMap: { __typename?: 'Project', id: string, baseMaps: Array<{ __typename?: 'CustomBaseMap', id: string, name: string, type: string, url: string, tileSize?: number | null, wmsVersion?: string | null, wmsLayers?: string | null, format?: string | null }> } };

export type CreateReferralMutationVariables = Exact<{
  email: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateReferralMutation = { __typename?: 'Mutation', createReferral: { __typename?: 'Referral', id: string, referredEmail: string, token: string, accountCreatedAt?: Date | null, organizationCreatedAt?: Date | null, subscriptionStartedAt?: Date | null, expiresAt: Date, createdAt: Date } };

export type DeleteReferralMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteReferralMutation = { __typename?: 'Mutation', deleteReferral: boolean };

export type CreateSavedViewMutationVariables = Exact<{
  input: CreateSavedViewInput;
}>;


export type CreateSavedViewMutation = { __typename?: 'Mutation', createSavedView: { __typename?: 'SavedView', id: string, projectId: string, name: string, description?: string | null, visibility: SavedViewVisibility, camera: any, clipBox: any, visibleLayerIds: Array<string>, baseMapId?: string | null, createdById: string, createdAt: Date, updatedAt: Date, createdBy?: { __typename?: 'User', id: string, name: string } | null } };

export type UpdateSavedViewMutationVariables = Exact<{
  input: UpdateSavedViewInput;
}>;


export type UpdateSavedViewMutation = { __typename?: 'Mutation', updateSavedView: { __typename?: 'SavedView', id: string, projectId: string, name: string, description?: string | null, visibility: SavedViewVisibility, camera: any, clipBox: any, visibleLayerIds: Array<string>, baseMapId?: string | null, createdById: string, createdAt: Date, updatedAt: Date, createdBy?: { __typename?: 'User', id: string, name: string } | null } };

export type DeleteSavedViewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSavedViewMutation = { __typename?: 'Mutation', deleteSavedView: boolean };

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'CreateSubscriptionResult', type: string, url: string } };

export type ChangeSubscriptionPlanMutationVariables = Exact<{
  input: ChangePlanInput;
}>;


export type ChangeSubscriptionPlanMutation = { __typename?: 'Mutation', changeSubscriptionPlan: boolean };

export type CancelSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: boolean };

export type ReactivateSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type ReactivateSubscriptionMutation = { __typename?: 'Mutation', reactivateSubscription: boolean };

export type ApplySubscriptionDiscountMutationVariables = Exact<{
  input: ApplyDiscountInput;
}>;


export type ApplySubscriptionDiscountMutation = { __typename?: 'Mutation', applySubscriptionDiscount: boolean };

export type RemoveSubscriptionDiscountMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type RemoveSubscriptionDiscountMutation = { __typename?: 'Mutation', removeSubscriptionDiscount: boolean };

export type CreateBillingPortalSessionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  returnUrl: Scalars['String']['input'];
}>;


export type CreateBillingPortalSessionMutation = { __typename?: 'Mutation', createBillingPortalSession: string };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, name: string, mobileNumber?: string | null, avatar?: { __typename?: 'Attachment', id: string, url: string } | null } };

export type UpdatePasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type UpdateEmailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateEmail: boolean };

export type RevokeSessionMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type RevokeSessionMutation = { __typename?: 'Mutation', revokeSession: boolean };

export type UpdateThemeMutationVariables = Exact<{
  theme: ThemePreference;
}>;


export type UpdateThemeMutation = { __typename?: 'Mutation', updateTheme: boolean };

export type UpdateLanguageMutationVariables = Exact<{
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateLanguageMutation = { __typename?: 'Mutation', updateLanguage: boolean };

export type UpdateViewerSettingsMutationVariables = Exact<{
  input: ViewerSettingsInput;
}>;


export type UpdateViewerSettingsMutation = { __typename?: 'Mutation', updateViewerSettings: boolean };

export type SaveOnboardingSurveyMutationVariables = Exact<{
  data: Scalars['JSON']['input'];
}>;


export type SaveOnboardingSurveyMutation = { __typename?: 'Mutation', saveOnboardingSurvey: boolean };

export type SetupTwoFactorMutationVariables = Exact<{
  mobileNumber: Scalars['String']['input'];
}>;


export type SetupTwoFactorMutation = { __typename?: 'Mutation', setupTwoFactor: { __typename?: 'SetupTwoFactorResult', secret: string } };

export type VerifyTwoFactorSetupMutationVariables = Exact<{
  secret: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifyTwoFactorSetupMutation = { __typename?: 'Mutation', verifyTwoFactorSetup: boolean };

export type SetupAuthenticatorTwoFactorMutationVariables = Exact<{ [key: string]: never; }>;


export type SetupAuthenticatorTwoFactorMutation = { __typename?: 'Mutation', setupAuthenticatorTwoFactor: { __typename?: 'SetupAuthenticatorResult', secret: string, otpauthUri: string } };

export type VerifyAuthenticatorTwoFactorSetupMutationVariables = Exact<{
  secret: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifyAuthenticatorTwoFactorSetupMutation = { __typename?: 'Mutation', verifyAuthenticatorTwoFactorSetup: boolean };

export type DisableTwoFactorMutationVariables = Exact<{
  secret: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type DisableTwoFactorMutation = { __typename?: 'Mutation', disableTwoFactor: boolean };

export type DisableAuthenticatorTwoFactorMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type DisableAuthenticatorTwoFactorMutation = { __typename?: 'Mutation', disableAuthenticatorTwoFactor: boolean };

export type GetAttachmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAttachmentsQuery = { __typename?: 'Query', attachments: Array<{ __typename?: 'Attachment', id: string, url: string, s3Key: string, uploadId?: string | null, filename: string, contentType: string, contentLength?: any | null, checksumSHA256Base64?: string | null, status: AttachmentStatus, createdAt: Date, updatedAt: Date, deletedAt?: Date | null, organizationId: string, projectId?: string | null }> };

export type GetAttachmentsByBatchQueryVariables = Exact<{
  batchId: Scalars['ID']['input'];
}>;


export type GetAttachmentsByBatchQuery = { __typename?: 'Query', attachmentsByBatch: Array<{ __typename?: 'Attachment', id: string, url: string, s3Key: string, uploadId?: string | null, filename: string, contentType: string, contentLength?: any | null, checksumSHA256Base64?: string | null, status: AttachmentStatus, createdAt: Date, updatedAt: Date, organizationId: string, projectId?: string | null }> };

export type StartUploadMutationVariables = Exact<{
  project: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  checksumSHA256Base64?: InputMaybe<Scalars['String']['input']>;
  batch?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StartUploadMutation = { __typename?: 'Mutation', attachment: { __typename?: 'Attachment', id: string, url: string, s3Key: string, uploadId?: string | null, batchId?: string | null, filename: string, contentType: string, contentLength?: any | null, checksumSHA256Base64?: string | null, status: AttachmentStatus, createdAt: Date, updatedAt: Date, organizationId: string, projectId?: string | null } };

export type StartUploadBatchMutationVariables = Exact<{
  project: Scalars['ID']['input'];
  numberOfAttachments: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartUploadBatchMutation = { __typename?: 'Mutation', batch: { __typename?: 'UploadBatch', id: string } };

export type CompleteUploadBatchMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompleteUploadBatchMutation = { __typename?: 'Mutation', success: boolean };

export type UploadPartMutationVariables = Exact<{
  attachmentId: Scalars['ID']['input'];
  partNumber: Scalars['Int']['input'];
  contentLength: Scalars['Int']['input'];
  checksumSHA256Base64: Scalars['String']['input'];
}>;


export type UploadPartMutation = { __typename?: 'Mutation', url: string };

export type CompleteUploadMutationVariables = Exact<{
  attachmentId: Scalars['ID']['input'];
  parts: Array<S3CompletedPart> | S3CompletedPart;
}>;


export type CompleteUploadMutation = { __typename?: 'Mutation', attachment: { __typename?: 'Attachment', id: string, url: string, s3Key: string, uploadId?: string | null, filename: string, contentType: string, contentLength?: any | null, checksumSHA256Base64?: string | null, status: AttachmentStatus, createdAt: Date, updatedAt: Date, organizationId: string, projectId?: string | null } };

export type AbortUploadMutationVariables = Exact<{
  attachmentId: Scalars['ID']['input'];
}>;


export type AbortUploadMutation = { __typename?: 'Mutation', success: boolean };

export type StartBatchMutationVariables = Exact<{
  project: Scalars['ID']['input'];
  numberOfAttachments: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartBatchMutation = { __typename?: 'Mutation', batch: { __typename?: 'UploadBatch', id: string, status: UploadBatchStatus, createdAt: Date, createdById?: string | null, numberOfAttachments: number, processingStartedAt?: Date | null, processingCompletedAt?: Date | null, srid: number } };

export type CompleteBatchMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompleteBatchMutation = { __typename?: 'Mutation', success: boolean };

export type GetBatchesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetBatchesQuery = { __typename?: 'Query', batches: Array<{ __typename?: 'UploadBatch', id: string, key: string, label?: string | null, kind: UploadBatchKind, status: UploadBatchStatus, createdAt: Date, numberOfAttachments: number, processingStartedAt?: Date | null, processingCompletedAt?: Date | null, srid: number, createdBy?: { __typename?: 'User', id: string, name: string, email: string, avatar?: { __typename?: 'Attachment', id: string, url: string } | null } | null }> };

export type GetBatchQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBatchQuery = { __typename?: 'Query', batch: { __typename?: 'UploadBatch', id: string, key: string, label?: string | null, kind: UploadBatchKind, status: UploadBatchStatus, createdAt: Date, createdById?: string | null, srid: number, numberOfAttachments: number, processingStartedAt?: Date | null, processingCompletedAt?: Date | null, totalBytes: any, createdBy?: { __typename?: 'User', id: string, name: string, email: string, avatar?: { __typename?: 'Attachment', id: string, url: string } | null } | null, attachments: Array<{ __typename?: 'Attachment', id: string, url: string, s3Key: string, filename: string, contentType: string, contentLength?: any | null, byproducts: Array<{ __typename?: 'Byproduct', id: string, filename: string, type: ByproductType, contentLength?: any | null, downloadUrl: string, expiresAt?: Date | null, isInternal: boolean }> }>, byproducts: Array<{ __typename?: 'Byproduct', id: string, filename: string, type: ByproductType, contentLength?: any | null, downloadUrl: string, expiresAt?: Date | null, isInternal: boolean, sourceAttachmentId?: string | null, processJobId: string, createdAt: Date }>, jobs: Array<{ __typename?: 'ProcessJob', id: string, type: ProcessJobType, status: ProcessJobStatus, inputJson: any, outputJson?: any | null, leaseUntil?: Date | null, attempts: number, isLeaf: boolean, batchId: string, parentItemId?: string | null, label?: string | null, logs?: string | null, logStream?: string | null, errorLogs?: string | null, startedAt?: Date | null, completedAt?: Date | null, estimatedCompletion?: Date | null, createdAt: Date, updatedAt: Date }> } };

export type StartBatchProcessingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  srid: Scalars['Int']['input'];
  type: ProcessJobType;
  dxfOutputVersion?: InputMaybe<Scalars['String']['input']>;
  minZoom?: InputMaybe<Scalars['Int']['input']>;
  maxZoom?: InputMaybe<Scalars['Int']['input']>;
  tileSize?: InputMaybe<Scalars['Int']['input']>;
  pointCloudAttributes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  compressImages?: InputMaybe<Scalars['Boolean']['input']>;
  blurLicensePlates?: InputMaybe<Scalars['Boolean']['input']>;
  blurFaces?: InputMaybe<Scalars['Boolean']['input']>;
  generateRcs?: InputMaybe<Scalars['Boolean']['input']>;
  generateDecimatedPointCloud?: InputMaybe<Scalars['Boolean']['input']>;
  generateGeotiff?: InputMaybe<Scalars['Boolean']['input']>;
  importUrl?: InputMaybe<Scalars['String']['input']>;
  rasterMode?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartBatchProcessingMutation = { __typename?: 'Mutation', success: boolean };

export type CreateAttachmentMutationVariables = Exact<{
  project?: InputMaybe<Scalars['ID']['input']>;
  filename: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  checksumSHA256Base64?: InputMaybe<Scalars['String']['input']>;
  type: UploadType;
}>;


export type CreateAttachmentMutation = { __typename?: 'Mutation', createAttachment: { __typename?: 'CreateAttachmentResponse', uploadUrl: string, attachment: { __typename?: 'Attachment', id: string, url: string, s3Key: string, uploadId?: string | null, batchId?: string | null, filename: string, contentType: string, contentLength?: any | null, checksumSHA256Base64?: string | null, status: AttachmentStatus, createdAt: Date, updatedAt: Date, organizationId: string, projectId?: string | null } } };

export type DeleteAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['ID']['input'];
}>;


export type DeleteAttachmentMutation = { __typename?: 'Mutation', success: boolean };

export type DeleteBatchMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBatchMutation = { __typename?: 'Mutation', success: boolean };

export type ResetBatchMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResetBatchMutation = { __typename?: 'Mutation', success: boolean };

export type LayerByproductsQueryVariables = Exact<{
  layerId: Scalars['ID']['input'];
}>;


export type LayerByproductsQuery = { __typename?: 'Query', layerByproducts: Array<{ __typename?: 'Byproduct', id: string, filename: string, type: ByproductType, contentLength?: any | null, downloadUrl: string, processJobId: string, createdAt: Date }> };

export type BatchByproductsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BatchByproductsQuery = { __typename?: 'Query', batch: { __typename?: 'UploadBatch', id: string, byproducts: Array<{ __typename?: 'Byproduct', id: string, filename: string, downloadUrl: string, processJobId: string }> } };

export type ClearanceProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type ClearanceProfilesQuery = { __typename?: 'Query', clearanceProfiles: Array<{ __typename?: 'ClearanceProfile', id: string, name: string, sourceAttribution?: string | null, vertices: Array<Array<number>>, createdById: string, createdAt: Date, updatedAt: Date }> };

export type SaveClearanceProfileMutationVariables = Exact<{
  input: SaveClearanceProfileInput;
}>;


export type SaveClearanceProfileMutation = { __typename?: 'Mutation', saveClearanceProfile: { __typename?: 'ClearanceProfile', id: string, name: string, sourceAttribution?: string | null, vertices: Array<Array<number>>, createdById: string, createdAt: Date, updatedAt: Date } };

export type DeleteClearanceProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClearanceProfileMutation = { __typename?: 'Mutation', deleteClearanceProfile: boolean };

export type StartClearanceMutationVariables = Exact<{
  input: StartClearanceInput;
}>;


export type StartClearanceMutation = { __typename?: 'Mutation', startClearance: string };

export type StartClipboxExportMutationVariables = Exact<{
  input: StartClipboxExportInput;
}>;


export type StartClipboxExportMutation = { __typename?: 'Mutation', startClipboxExport: string };

export type DashboardStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardStatsQuery = { __typename?: 'Query', dashboardStats: { __typename?: 'DashboardStats', totalLayers: number, projects: Array<{ __typename?: 'DashboardProject', id: string, name: string, storageUsedBytes: any, positionWGS84?: any | null, createdAt: Date, layerCounts: Array<{ __typename?: 'LayerTypeCount', type: string, count: number }> }>, layerTypeCounts: Array<{ __typename?: 'LayerTypeCount', type: string, count: number }> } };

export type SharedLinkDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type SharedLinkDashboardQuery = { __typename?: 'Query', sharedLinkDashboard: { __typename?: 'SharedLinkDashboard', totalLinks: number, dailyViews: Array<{ __typename?: 'DailyViews', date: string, count: number }>, topProjectsByLinks: Array<{ __typename?: 'ProjectByLinks', projectId: string, projectName: string, linkCount: number }>, topLinksByViews: Array<{ __typename?: 'LinkWithViews', id: string, name?: string | null, projectName?: string | null, viewCount: number }> } };

export type StartDeviationAnalysisMutationVariables = Exact<{
  input: StartDeviationAnalysisInput;
}>;


export type StartDeviationAnalysisMutation = { __typename?: 'Mutation', startDeviationAnalysis: string };

export type DeviationJobsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type DeviationJobsQuery = { __typename?: 'Query', deviationJobs: Array<{ __typename?: 'ProcessJob', id: string, status: ProcessJobStatus, label?: string | null, batchId: string, inputJson: any, outputJson?: any | null, errorLogs?: string | null, createdAt: Date, startedAt?: Date | null, completedAt?: Date | null }> };

export type FeaturesQueryVariables = Exact<{
  layerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FeaturesQuery = { __typename?: 'Query', featuresByLayer: Array<{ __typename?: 'Feature', id: string, serial: number, layerId?: string | null, geometryWGS84: any, geometry: any, properties: any }> };

export type FeaturesByProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type FeaturesByProjectQuery = { __typename?: 'Query', features: Array<{ __typename?: 'Feature', id: string, serial: number, layerId?: string | null, geometryWGS84: any, geometry: any, properties: any }> };

export type FeatureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FeatureQuery = { __typename?: 'Query', feature: { __typename?: 'Feature', id: string, serial: number, layerId?: string | null, geometryWGS84: any, geometry: any, properties: any } };

export type CreateFeatureMutationVariables = Exact<{
  input: CreateFeatureInput;
}>;


export type CreateFeatureMutation = { __typename?: 'Mutation', createFeature: { __typename?: 'Feature', id: string, serial: number, layerId?: string | null, geometryWGS84: any, geometry: any, properties: any } };

export type UpdateFeatureMutationVariables = Exact<{
  input: UpdateFeatureInput;
}>;


export type UpdateFeatureMutation = { __typename?: 'Mutation', updateFeature: { __typename?: 'Feature', id: string, serial: number, layerId?: string | null, geometryWGS84: any, geometry: any, properties: any } };

export type FeaturesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FeaturesByIdsQuery = { __typename?: 'Query', featuresByIds: Array<{ __typename?: 'Feature', id: string, serial: number, layerId?: string | null, properties: any }> };

export type UpdateFeaturesMutationVariables = Exact<{
  input: Array<UpdateFeatureInput> | UpdateFeatureInput;
}>;


export type UpdateFeaturesMutation = { __typename?: 'Mutation', updateFeatures: Array<{ __typename?: 'Feature', id: string, serial: number, layerId?: string | null, properties: any }> };

export type DeleteFeatureMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFeatureMutation = { __typename?: 'Mutation', deleteFeature: boolean };

export type DeleteFeaturesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteFeaturesMutation = { __typename?: 'Mutation', deleteFeatures: boolean };

export type SridsQueryVariables = Exact<{ [key: string]: never; }>;


export type SridsQuery = { __typename?: 'Query', srids: Array<{ __typename?: 'SRID', srid: number, name: string, projection: string }> };

export type FeaturesPaginatedQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  layerId?: InputMaybe<Scalars['ID']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<FeatureOrder>;
  limit: Scalars['Int']['input'];
  filters?: InputMaybe<Array<FeatureFilter> | FeatureFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type FeaturesPaginatedQuery = { __typename?: 'Query', featuresPaginated: { __typename?: 'FeaturePaginated', total: number, cursor?: string | null, features: Array<{ __typename?: 'Feature', id: string, serial: number, properties: any, layerId?: string | null }> } };

export type FeatureSummaryQueryVariables = Exact<{
  layerId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<FeatureFilter> | FeatureFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type FeatureSummaryQuery = { __typename?: 'Query', featureSummary: { __typename?: 'FeatureSummary', pointCount: number, lineCount: number, polygonCount: number, totalLineLengthM: number, totalPolygonAreaSqm: number, totalPolygonPerimeterM: number } };

export type FeatureAttachmentsQueryVariables = Exact<{
  featureId: Scalars['ID']['input'];
}>;


export type FeatureAttachmentsQuery = { __typename?: 'Query', featureAttachments: Array<{ __typename?: 'FeatureAttachment', id: string, label: string, uploadedById: string, attachmentId: string, createdAt: Date, updatedAt: Date, attachment: { __typename?: 'Attachment', id: string, url: string, filename: string, contentType: string, contentLength?: any | null }, uploadedBy: { __typename?: 'User', id: string, name: string, email: string, avatar?: { __typename?: 'Attachment', url: string } | null } }> };

export type CreateFeatureAttachmentMutationVariables = Exact<{
  input: CreateFeatureAttachmentInput;
}>;


export type CreateFeatureAttachmentMutation = { __typename?: 'Mutation', createFeatureAttachment: { __typename?: 'FeatureAttachment', id: string, label: string, uploadedById: string, attachmentId: string, createdAt: Date, attachment: { __typename?: 'Attachment', id: string, url: string, filename: string, contentType: string, contentLength?: any | null } } };

export type DeleteFeatureAttachmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFeatureAttachmentMutation = { __typename?: 'Mutation', deleteFeatureAttachment: boolean };

export type DownloadFeaturesMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  layerId?: InputMaybe<Scalars['ID']['input']>;
  exportType: ExportType;
}>;


export type DownloadFeaturesMutation = { __typename?: 'Mutation', downloadFeatures: string };

export type GoogleImagesByPositionQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
}>;


export type GoogleImagesByPositionQuery = { __typename?: 'Query', images: Array<{ __typename?: 'GoogleImage', id: string, panoId: string, root: string, heading: number, roll: number, tilt: number, width: number, height: number, copyright: string, date: string, locationWGS84: any, createdAt: Date }> };

export type StartGroundClassificationMutationVariables = Exact<{
  input: StartGroundClassificationInput;
}>;


export type StartGroundClassificationMutation = { __typename?: 'Mutation', startGroundClassification: string };

export type ImagesQueryVariables = Exact<{
  layerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ImagesQuery = { __typename?: 'Query', imagesByLayer: Array<{ __typename?: 'Image', id: string, organizationId: string, projectId: string, attachmentId?: string | null, layerId?: string | null, locationWGS84: any, location: any, groupId: number, width: number, height: number, pixelWidth: number, pixelHeight: number, focalLengthX?: number | null, focalLengthY?: number | null, principalPointX?: number | null, principalPointY?: number | null, rotationMatrix: Array<number>, rotationQuaternion: Array<number>, filename: string, cameraType?: number | null, k1?: number | null, k2?: number | null, k3?: number | null, k4?: number | null, p1?: number | null, p2?: number | null, hasCompressedVariants: boolean, smallFilename?: string | null, largeFilename?: string | null, hasBlurredVariants: boolean, blurredFilename?: string | null, smallBlurredFilename?: string | null, largeBlurredFilename?: string | null, createdAt: Date, updatedAt: Date }> };

export type StartLandxmlExportMutationVariables = Exact<{
  input: StartLandxmlExportInput;
}>;


export type StartLandxmlExportMutation = { __typename?: 'Mutation', startLandxmlExport: string };

export type LayersQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type LayersQuery = { __typename?: 'Query', layers: Array<{ __typename?: 'Layer', id: string, parentLayerId?: string | null, name: string, description?: string | null, type: LayerType, root?: string | null, metadata?: any | null, bbox?: any | null, bboxNew?: any | null, center?: any | null, isHidden: boolean, isLocked: boolean, isEphemeral: boolean, ephemeralExpiresAt?: Date | null, ephemeralSourceBytes?: any | null, createdAt: Date, updatedAt: Date, propertyAliases: Array<{ __typename?: 'PropertyAlias', property: string, alias: string }>, settings: { __typename?: 'LayerSettings', pointCloudMaterialColorSource: number, pointCloudMaterialColor: PointColorType, pointCloudFixedColor: string, modelIsWireframe: boolean, modelDefaultColor: string, modelOpacity: number, modelColorBy: string, landxmlSurfaceColorMode: string, landxmlSurfaceColormap: PointColorType, surfaceDifferenceColormap: PointColorType, scalarRangeMin?: number | null, scalarRangeMax?: number | null, imagePointColor: string, vectorDefaultColor: string, vectorDefaultOpacity: number, vectorIsWireframe: boolean, vectorDefaultPointSize: number, vectorLineRenderAsPipe: boolean, vectorLineWidth: number, rasterOpacity: number, rasterContrast: number, rasterSaturation: number, rasterBrightness: number, offsetX: number, offsetY: number, offsetZ: number, rotationX: number, rotationY: number, rotationZ: number, modelClassColors: Array<{ __typename?: 'ModelClassColor', class: string, color: string }>, landxmlCategoryColors: { __typename?: 'LandxmlCategoryColors', surface: string, alignment: string, parcel: string, breakline: string, pipe: string, structure: string }, pointCloudClasses: Array<{ __typename?: 'PointCloudClassSettings', color: string, isEnabled: boolean }>, sectionOverlays: Array<{ __typename?: 'SectionOverlaySetting', id: string, kind: SectionOverlayKind, layerId: string, ref?: string | null, pcMethod?: string | null, hidden: boolean }> } }> };

export type CreateLayerMutationVariables = Exact<{
  input: CreateLayerInput;
}>;


export type CreateLayerMutation = { __typename?: 'Mutation', createLayer: { __typename?: 'Layer', id: string } };

export type UpdateLayerMutationVariables = Exact<{
  input: UpdateLayerInput;
}>;


export type UpdateLayerMutation = { __typename?: 'Mutation', updateLayer: { __typename?: 'Layer', id: string, name: string, description?: string | null, createdAt: Date, updatedAt: Date } };

export type DeleteLayerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLayerMutation = { __typename?: 'Mutation', deleteLayer: boolean };

export type LayerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LayerQuery = { __typename?: 'Query', layer: { __typename?: 'Layer', id: string, parentLayerId?: string | null, name: string, description?: string | null, type: LayerType, root?: string | null, metadata?: any | null, bbox?: any | null, bboxNew?: any | null, center?: any | null, isHidden: boolean, isLocked: boolean, createdAt: Date, updatedAt: Date, sourceAttachment?: { __typename?: 'Attachment', batchId?: string | null, filename: string, contentLength?: any | null, createdAt: Date } | null, settings: { __typename?: 'LayerSettings', pointCloudMaterialColorSource: number, pointCloudMaterialColor: PointColorType, pointCloudFixedColor: string, modelIsWireframe: boolean, modelDefaultColor: string, modelOpacity: number, modelColorBy: string, landxmlSurfaceColorMode: string, landxmlSurfaceColormap: PointColorType, surfaceDifferenceColormap: PointColorType, scalarRangeMin?: number | null, scalarRangeMax?: number | null, imagePointColor: string, imageBrightness: number, imageContrast: number, imageSaturation: number, imageOpacity: number, vectorDefaultColor: string, vectorDefaultOpacity: number, vectorIsWireframe: boolean, vectorDefaultPointSize: number, vectorLineRenderAsPipe: boolean, vectorLineWidth: number, rasterOpacity: number, rasterContrast: number, rasterSaturation: number, rasterBrightness: number, offsetX: number, offsetY: number, offsetZ: number, rotationX: number, rotationY: number, rotationZ: number, modelClassColors: Array<{ __typename?: 'ModelClassColor', class: string, color: string }>, landxmlCategoryColors: { __typename?: 'LandxmlCategoryColors', surface: string, alignment: string, parcel: string, breakline: string, pipe: string, structure: string }, pointCloudClasses: Array<{ __typename?: 'PointCloudClassSettings', color: string, isEnabled: boolean }>, sectionOverlays: Array<{ __typename?: 'SectionOverlaySetting', id: string, kind: SectionOverlayKind, layerId: string, ref?: string | null, pcMethod?: string | null, hidden: boolean }> } } };

export type UpdateLayerSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: LayerSettingsInput;
}>;


export type UpdateLayerSettingsMutation = { __typename?: 'Mutation', updateLayerSettings: boolean };

export type UpdateLayersSettingsMutationVariables = Exact<{
  input: Array<UpdateLayerSettingsBatchInput> | UpdateLayerSettingsBatchInput;
}>;


export type UpdateLayersSettingsMutation = { __typename?: 'Mutation', updateLayersSettings: boolean };

export type LayerSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LayerSettingsQuery = { __typename?: 'Query', layer: { __typename?: 'Layer', id: string, settings: { __typename?: 'LayerSettings', pointCloudMaterialColorSource: number, pointCloudMaterialColor: PointColorType, pointCloudFixedColor: string, modelIsWireframe: boolean, modelDefaultColor: string, modelOpacity: number, modelColorBy: string, landxmlSurfaceColorMode: string, landxmlSurfaceColormap: PointColorType, surfaceDifferenceColormap: PointColorType, scalarRangeMin?: number | null, scalarRangeMax?: number | null, imagePointColor: string, imageBrightness: number, imageContrast: number, imageSaturation: number, imageOpacity: number, vectorDefaultColor: string, vectorDefaultOpacity: number, vectorIsWireframe: boolean, vectorDefaultPointSize: number, vectorLineRenderAsPipe: boolean, vectorLineWidth: number, rasterOpacity: number, rasterContrast: number, rasterSaturation: number, rasterBrightness: number, offsetX: number, offsetY: number, offsetZ: number, rotationX: number, rotationY: number, rotationZ: number, modelClassColors: Array<{ __typename?: 'ModelClassColor', class: string, color: string }>, landxmlCategoryColors: { __typename?: 'LandxmlCategoryColors', surface: string, alignment: string, parcel: string, breakline: string, pipe: string, structure: string }, pointCloudClasses: Array<{ __typename?: 'PointCloudClassSettings', color: string, isEnabled: boolean }>, sectionOverlays: Array<{ __typename?: 'SectionOverlaySetting', id: string, kind: SectionOverlayKind, layerId: string, ref?: string | null, pcMethod?: string | null, hidden: boolean }> } } };

export type LayerPropertiesQueryVariables = Exact<{
  layerId: Scalars['ID']['input'];
}>;


export type LayerPropertiesQuery = { __typename?: 'Query', layerProperties: Array<string> };

export type LayerPropertyValuesQueryVariables = Exact<{
  layerId: Scalars['ID']['input'];
}>;


export type LayerPropertyValuesQuery = { __typename?: 'Query', layerPropertyValues: Array<{ __typename?: 'PropertyValues', property: string, values: Array<string> }> };

export type QuickUploadLayerMutationVariables = Exact<{
  input: QuickUploadLayerInput;
}>;


export type QuickUploadLayerMutation = { __typename?: 'Mutation', quickUploadLayer: { __typename?: 'QuickUploadLayerResult', expiresAt: Date, layer: { __typename?: 'Layer', id: string, name: string, type: LayerType, isEphemeral: boolean, ephemeralExpiresAt?: Date | null, ephemeralSourceBytes?: any | null } } };

export type TouchEphemeralLayersMutationVariables = Exact<{
  layerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type TouchEphemeralLayersMutation = { __typename?: 'Mutation', touchEphemeralLayers: boolean };

export type RefreshWmsLayerMutationVariables = Exact<{
  layerId: Scalars['ID']['input'];
}>;


export type RefreshWmsLayerMutation = { __typename?: 'Mutation', refreshWmsLayer: { __typename?: 'Layer', id: string, name: string, type: LayerType, metadata?: any | null, subLayers: Array<{ __typename?: 'Layer', id: string, name: string, type: LayerType, metadata?: any | null, bbox?: any | null, isHidden: boolean }> } };

export type MaterializeSectionOverlaysMutationVariables = Exact<{
  layerId: Scalars['ID']['input'];
}>;


export type MaterializeSectionOverlaysMutation = { __typename?: 'Mutation', materializeSectionOverlays: string };

export type StartLayerStackMutationVariables = Exact<{
  input: StartLayerStackInput;
}>;


export type StartLayerStackMutation = { __typename?: 'Mutation', startLayerStack: string };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, firstName: string, lastName: string, name: string, email: string, mobileNumber?: string | null, avatarId?: string | null, onboardingSurveyCompleted: boolean, onboardingTourCompleted: boolean, twoFactorEnabled: boolean, twoFactorType?: TwoFactorType | null, theme: ThemePreference, language?: string | null, isReferrer: boolean, avatar?: { __typename?: 'Attachment', url: string } | null, featurebaseUser?: { __typename?: 'FeaturebaseUser', organization: string, email?: string | null, name?: string | null, userId: string, profilePicture?: string | null, featurebaseJwt?: string | null } | null, viewerSettings: { __typename?: 'UserViewerSettings', pointCloudPointSizeType: PointCloudPointSizeType, pointCloudPointSize: number, orthoPointSize: number, pointCloudLoadingDistance: number, pointCloudMinNodePixelSize: number, pointCloudPointBudget: number, showLayerSource: boolean, showLayerUnderType: boolean, showImagePOIs: boolean, showAllImagePOIs: boolean, imagePOIMaxDistance: number, showPointCloudBoundingBoxes: boolean, showOrthoGrid: boolean, googleStreetViewPoiColor?: string | null, backgroundColor?: string | null, actionPosition: ActionPosition, customBaseMaps?: Array<{ __typename?: 'CustomBaseMap', id: string, name: string, type: string, url: string, tileSize?: number | null, wmsVersion?: string | null, wmsLayers?: string | null, format?: string | null }> | null } } };

export type UserPasskeysQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPasskeysQuery = { __typename?: 'Query', userPasskeys: Array<{ __typename?: 'UserPasskey', id: string, name: string, createdAt: Date, lastUsedAt?: Date | null }> };

export type RenamePasskeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenamePasskeyMutation = { __typename?: 'Mutation', renamePasskey: boolean };

export type DeletePasskeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePasskeyMutation = { __typename?: 'Mutation', deletePasskey: boolean };

export type MeUserSessionsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type MeUserSessionsQuery = { __typename?: 'Query', userSessions: Array<{ __typename?: 'UserSession', id: string, createdAt: Date, expiresAt: Date, lastUsedAt: Date, revokedAt?: Date | null, ipHash: string, loginMethod: UserSessionMethod, country?: string | null, userAgent?: string | null, status: UserSessionStatus }> };

export type StartMeshExportMutationVariables = Exact<{
  input: StartMeshExportInput;
}>;


export type StartMeshExportMutation = { __typename?: 'Mutation', startMeshExport: string };

export type ProjectOfflineManifestQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectOfflineManifestQuery = { __typename?: 'Query', projectOfflineManifest: { __typename?: 'OfflineManifest', projectId: string, totalBytes: number, layerVersions: any, files: Array<{ __typename?: 'OfflineManifestFile', url: string, sizeBytes: number, layerId: string, kind: LayerType }> } };

export type MyOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyOrganizationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: string, name: string, slug?: string | null, role?: UserOrganizationRole | null, authBrandingEnabled: boolean, storageUsedBytes: any, storageLimitBytes: any, ephemeralBytes: any, logo?: { __typename?: 'Attachment', url: string } | null, subscription: { __typename?: 'SubscriptionInfo', productLine: ProductLine, plan: SubscriptionPlan, isCustom: boolean, maxSeats: number, seatsUsed: number, billingStatus: BillingStatus, trialEndsAt?: Date | null } }> };

export type OrganizationUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, name: string, email: string, role?: UserOrganizationRole | null, joinedAt?: Date | null, createdAt: Date, avatar?: { __typename?: 'Attachment', url: string } | null }> };

export type RemoveUserFromOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveUserFromOrganizationMutation = { __typename?: 'Mutation', removeUserFromOrganization: boolean };

export type UpdateUserRoleInOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  role: UserOrganizationRole;
}>;


export type UpdateUserRoleInOrganizationMutation = { __typename?: 'Mutation', updateUserRoleInOrganization: boolean };

export type InviteUserToOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  role: UserOrganizationRole;
  firstname: Scalars['String']['input'];
  lastname?: InputMaybe<Scalars['String']['input']>;
}>;


export type InviteUserToOrganizationMutation = { __typename?: 'Mutation', inviteUserToOrganization: boolean };

export type InviteUsersToOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  invitees: Array<InviteUserInput> | InviteUserInput;
}>;


export type InviteUsersToOrganizationMutation = { __typename?: 'Mutation', inviteUsersToOrganization: boolean };

export type OrganizationInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationInvitationsQuery = { __typename?: 'Query', invitations: Array<{ __typename?: 'UserInvitation', id: string, email: string, role: UserOrganizationRole, createdAt: Date, expiresAt: Date, acceptedAt?: Date | null }> };

export type RevokeInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RevokeInvitationMutation = { __typename?: 'Mutation', revokeInvitation: boolean };

export type ResendInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResendInvitationMutation = { __typename?: 'Mutation', resendInvitation: boolean };

export type AcceptInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'UserInvitationResult', success: boolean, error?: string | null, organization?: { __typename?: 'Organization', id: string, name: string } | null } };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, name: string, authBrandingEnabled: boolean, logo?: { __typename?: 'Attachment', url: string } | null } };

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization: boolean };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string, name: string, slug?: string | null, role?: UserOrganizationRole | null } };

export type SlugAvailableQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type SlugAvailableQuery = { __typename?: 'Query', slugAvailable: boolean };

export type InviteOnboardingUsersMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  invitees: Array<OnboardingInviteInput> | OnboardingInviteInput;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type InviteOnboardingUsersMutation = { __typename?: 'Mutation', inviteOnboardingUsers: boolean };

export type CustomDomainStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomDomainStatusQuery = { __typename?: 'Query', customDomainStatus?: { __typename?: 'OrganizationCustomDomain', id: string, domain: string, status: CustomDomainStatus, cnameTarget: string, dnsVerified: boolean, createdAt: Date, verifiedAt?: Date | null } | null };

export type AddCustomDomainMutationVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type AddCustomDomainMutation = { __typename?: 'Mutation', addCustomDomain: { __typename?: 'OrganizationCustomDomain', id: string, domain: string, status: CustomDomainStatus, cnameTarget: string, dnsVerified: boolean } };

export type RemoveCustomDomainMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveCustomDomainMutation = { __typename?: 'Mutation', removeCustomDomain: boolean };

export type MyProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', id: string, name: string, srid: number, organizationId: string, folderId?: string | null, storageUsedBytes: any, archiveStatus: ArchiveStatus, archiveBytes?: any | null, retentionUntil?: Date | null }> };

export type ArchivedProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ArchivedProjectsQuery = { __typename?: 'Query', archivedProjects: Array<{ __typename?: 'Project', id: string, name: string, organizationId: string, archiveStatus: ArchiveStatus, archivedAt?: Date | null, archiveBytes?: any | null, archiveNonArchivedBytes?: any | null, retentionUntil?: Date | null, restoreRequestedAt?: Date | null, restoreRetrievedAt?: Date | null, restoreExpiresAt?: Date | null, archiveError?: string | null, storageUsedBytes: any }> };

export type ArchivePreviewQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ArchivePreviewQuery = { __typename?: 'Query', archivePreview: { __typename?: 'ArchivePreview', archivableBytes: any, nonArchivableBytes: any, archivableFileCount: number, nonArchivableFileCount: number, monthlyCostCurrent: number, monthlyCostArchived: number, retrievalFeeEstimate: number, quotaAfterArchive: any, retentionEndsAt: Date, blockingJobs: Array<{ __typename?: 'ArchiveBlockingJob', id: string, type: string, status: string, label?: string | null }> } };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, name: string, description?: string | null, srid: number, proj4String?: string | null, organizationId: string, initialPosition?: any | null, initialAngle: number, defaultThirdPersonView: boolean, archiveStatus: ArchiveStatus, archiveBytes?: any | null, retentionUntil?: Date | null, storageUsedBytes: any, ephemeralBytes: any, baseMaps: Array<{ __typename?: 'CustomBaseMap', id: string, name: string, type: string, url: string, tileSize?: number | null, wmsVersion?: string | null, wmsLayers?: string | null, format?: string | null }> } };

export type SharedLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type SharedLinkQuery = { __typename?: 'Query', sharedLink?: { __typename?: 'ProjectLink', id: string, allowQuickUploads: boolean, expiresAt: Date, hasPassword: boolean } | null };

export type GetSharedProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSharedProjectQuery = { __typename?: 'Query', sharedProject: { __typename?: 'Project', id: string, name: string, srid: number, proj4String?: string | null, organizationId: string, initialPosition?: any | null, initialAngle: number, defaultThirdPersonView: boolean, baseMaps: Array<{ __typename?: 'CustomBaseMap', id: string, name: string, type: string, url: string, tileSize?: number | null, wmsVersion?: string | null, wmsLayers?: string | null, format?: string | null }>, organization?: { __typename?: 'Organization', name: string, slug?: string | null, logo?: { __typename?: 'Attachment', url: string } | null } | null } };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string, name: string, srid: number } };

export type GetProjectJobsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectJobsQuery = { __typename?: 'Query', jobs: Array<{ __typename?: 'ProcessJob', id: string, type: ProcessJobType, status: ProcessJobStatus, inputJson: any, outputJson?: any | null, logs?: string | null, errorLogs?: string | null, startedAt?: Date | null, completedAt?: Date | null, estimatedCompletion?: Date | null, leaseUntil?: Date | null, attempts: number, isLeaf: boolean, batchId: string, parentItemId?: string | null, createdAt: Date, updatedAt: Date }> };

export type GetProjectJobsByBatchQueryVariables = Exact<{
  batchId: Scalars['ID']['input'];
}>;


export type GetProjectJobsByBatchQuery = { __typename?: 'Query', jobs: Array<{ __typename?: 'ProcessJob', id: string, type: ProcessJobType, status: ProcessJobStatus, inputJson: any, outputJson?: any | null, logs?: string | null, errorLogs?: string | null, startedAt?: Date | null, completedAt?: Date | null, estimatedCompletion?: Date | null, leaseUntil?: Date | null, attempts: number, isLeaf: boolean, batchId: string, parentItemId?: string | null, createdAt: Date, updatedAt: Date }> };

export type GetProjectLinksQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectLinksQuery = { __typename?: 'Query', projectLinks: Array<{ __typename?: 'ProjectLink', id: string, projectId: string, name?: string | null, token: string, hasPassword: boolean, expiresAt: Date, createdAt: Date, createdById: string, status: ProjectLinkStatus, viewCount: number, allowQuickUploads: boolean, ephemeralBytes: any, createdBy?: { __typename?: 'User', id: string, name: string, email: string, avatar?: { __typename?: 'Attachment', url: string } | null } | null }> };

export type GetAllProjectLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectLinksQuery = { __typename?: 'Query', allProjectLinks: Array<{ __typename?: 'ProjectLink', id: string, projectId: string, name?: string | null, token: string, hasPassword: boolean, expiresAt: Date, createdAt: Date, createdById: string, status: ProjectLinkStatus, viewCount: number, allowQuickUploads: boolean, ephemeralBytes: any, project?: { __typename?: 'Project', id: string, name: string } | null, createdBy?: { __typename?: 'User', id: string, name: string, email: string, avatar?: { __typename?: 'Attachment', url: string } | null } | null }> };

export type ProjectFoldersQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectFoldersQuery = { __typename?: 'Query', projectFolders: Array<{ __typename?: 'ProjectFolder', id: string, name: string }> };

export type CreateProjectFolderMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateProjectFolderMutation = { __typename?: 'Mutation', createProjectFolder: { __typename?: 'ProjectFolder', id: string, name: string } };

export type RenameProjectFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameProjectFolderMutation = { __typename?: 'Mutation', renameProjectFolder: { __typename?: 'ProjectFolder', id: string, name: string } };

export type DeleteProjectFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectFolderMutation = { __typename?: 'Mutation', deleteProjectFolder: boolean };

export type MoveProjectToFolderMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  folderId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MoveProjectToFolderMutation = { __typename?: 'Mutation', moveProjectToFolder: { __typename?: 'Project', id: string, folderId?: string | null } };

export type StartRainfallAnalysisMutationVariables = Exact<{
  input: StartRainfallAnalysisInput;
}>;


export type StartRainfallAnalysisMutation = { __typename?: 'Mutation', startRainfallAnalysis: string };

export type MyReferralsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyReferralsQuery = { __typename?: 'Query', myReferrals: Array<{ __typename?: 'Referral', id: string, referredEmail: string, token: string, accountCreatedAt?: Date | null, organizationCreatedAt?: Date | null, subscriptionStartedAt?: Date | null, expiresAt: Date, createdAt: Date, referredUser?: { __typename?: 'User', firstName: string, lastName: string, name: string } | null, organization?: { __typename?: 'Organization', id: string, name: string, slug?: string | null } | null }> };

export type StartPdfReportMutationVariables = Exact<{
  input: StartPdfReportInput;
}>;


export type StartPdfReportMutation = { __typename?: 'Mutation', startPdfReport: string };

export type SavedViewsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type SavedViewsQuery = { __typename?: 'Query', savedViews: Array<{ __typename?: 'SavedView', id: string, projectId: string, name: string, description?: string | null, visibility: SavedViewVisibility, camera: any, clipBox: any, visibleLayerIds: Array<string>, baseMapId?: string | null, createdById: string, createdAt: Date, updatedAt: Date, createdBy?: { __typename?: 'User', id: string, name: string } | null }> };

export type SearchProjectsQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchProjectsQuery = { __typename?: 'Query', searchProjects: Array<{ __typename?: 'SearchProjectResult', id: string, name: string, description?: string | null, organizationId: string, organizationName: string, organizationSlug: string }> };

export type OrganizationWithSubscriptionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationWithSubscriptionQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, name: string, storageUsedBytes: any, storageLimitBytes: any, subscription: { __typename?: 'SubscriptionInfo', productLine: ProductLine, plan: SubscriptionPlan, isCustom: boolean, maxSeats: number, seatsUsed: number, billingStatus: BillingStatus, collectionMethod?: CollectionMethod | null, billingInterval?: BillingInterval | null, storageLimitBytes: any, currentPeriodEnd?: Date | null, cancelAtPeriodEnd: boolean, cancelAt?: Date | null, scheduledPlan?: SubscriptionPlan | null, scheduledChangeAt?: Date | null, trialEndsAt?: Date | null } } };

export type SubscriptionDetailsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type SubscriptionDetailsQuery = { __typename?: 'Query', subscriptionDetails: { __typename?: 'SubscriptionDetails', info: { __typename?: 'SubscriptionInfo', productLine: ProductLine, plan: SubscriptionPlan, isCustom: boolean, maxSeats: number, seatsUsed: number, billingStatus: BillingStatus, collectionMethod?: CollectionMethod | null, billingInterval?: BillingInterval | null, storageLimitBytes: any, currentPeriodEnd?: Date | null, cancelAtPeriodEnd: boolean, cancelAt?: Date | null, scheduledPlan?: SubscriptionPlan | null, scheduledChangeAt?: Date | null, trialEndsAt?: Date | null }, invoices: Array<{ __typename?: 'Invoice', id: string, number?: string | null, status: string, amountDue: number, amountPaid: number, currency: string, created: Date, dueDate?: Date | null, hostedInvoiceUrl?: string | null, pdfUrl?: string | null, taxInvoiceUrl?: string | null, taxInvoiceNumber?: string | null }>, nextInvoicePreview?: { __typename?: 'InvoicePreview', amountDue: number, currency: string, periodStart: Date, periodEnd: Date, lines: Array<{ __typename?: 'InvoiceLineItem', description: string, amount: number, quantity?: number | null }> } | null, discount?: { __typename?: 'DiscountInfo', promoCodeId?: string | null, couponId: string, name?: string | null, percentOff?: number | null, amountOff?: number | null, expiresAt?: Date | null } | null } };

export type SubscriptionPaymentUrlQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type SubscriptionPaymentUrlQuery = { __typename?: 'Query', subscriptionPaymentUrl?: string | null };

export type ValidatePromoCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ValidatePromoCodeQuery = { __typename?: 'Query', validatePromoCode: { __typename?: 'PromoCodeValidation', valid: boolean, name?: string | null, percentOff?: number | null, amountOff?: number | null } };

export type SubscriptionPricingQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionPricingQuery = { __typename?: 'Query', subscriptionPricing: { __typename?: 'PricingInfo', currency: string, plans: Array<{ __typename?: 'PlanPrice', plan: SubscriptionPlan, monthlyAmount: number, annualAmount: number }> } };

export type StartSurfaceDifferenceMutationVariables = Exact<{
  input: StartSurfaceDifferenceInput;
}>;


export type StartSurfaceDifferenceMutation = { __typename?: 'Mutation', startSurfaceDifference: string };

export type SurfaceDifferenceJobsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type SurfaceDifferenceJobsQuery = { __typename?: 'Query', surfaceDifferenceJobs: Array<{ __typename?: 'ProcessJob', id: string, status: ProcessJobStatus, label?: string | null, batchId: string, inputJson: any, outputJson?: any | null, errorLogs?: string | null, createdAt: Date, startedAt?: Date | null, completedAt?: Date | null }> };

export type StartVectorExportMutationVariables = Exact<{
  input: StartVectorExportInput;
}>;


export type StartVectorExportMutation = { __typename?: 'Mutation', startVectorExport: string };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const UpdateProjectDocument = new TypedDocumentString(`
    mutation UpdateProject($input: UpdateProjectInput!) {
  updateProject(input: $input) {
    id
    name
    description
    srid
    defaultThirdPersonView
  }
}
    `) as unknown as TypedDocumentString<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const CreateProjectLinkDocument = new TypedDocumentString(`
    mutation CreateProjectLink($projectId: ID!, $expiresAt: DateTime!, $name: String!, $password: String, $allowQuickUploads: Boolean) {
  createProjectLink(
    projectId: $projectId
    expiresAt: $expiresAt
    name: $name
    password: $password
    allowQuickUploads: $allowQuickUploads
  ) {
    id
    projectId
    token
    hasPassword
    expiresAt
    createdAt
    createdById
    allowQuickUploads
    createdBy {
      id
      name
      email
    }
  }
}
    `) as unknown as TypedDocumentString<CreateProjectLinkMutation, CreateProjectLinkMutationVariables>;
export const UpdateProjectLinkPasswordDocument = new TypedDocumentString(`
    mutation UpdateProjectLinkPassword($id: ID!, $password: String) {
  updateProjectLinkPassword(id: $id, password: $password) {
    id
    hasPassword
  }
}
    `) as unknown as TypedDocumentString<UpdateProjectLinkPasswordMutation, UpdateProjectLinkPasswordMutationVariables>;
export const UpdateProjectLinkAllowQuickUploadsDocument = new TypedDocumentString(`
    mutation UpdateProjectLinkAllowQuickUploads($id: ID!, $allowQuickUploads: Boolean!) {
  updateProjectLinkAllowQuickUploads(
    id: $id
    allowQuickUploads: $allowQuickUploads
  ) {
    id
    allowQuickUploads
  }
}
    `) as unknown as TypedDocumentString<UpdateProjectLinkAllowQuickUploadsMutation, UpdateProjectLinkAllowQuickUploadsMutationVariables>;
export const DeleteProjectLinkDocument = new TypedDocumentString(`
    mutation DeleteProjectLink($id: ID!) {
  deleteProjectLink(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteProjectLinkMutation, DeleteProjectLinkMutationVariables>;
export const DeleteProjectDocument = new TypedDocumentString(`
    mutation DeleteProject($id: ID!) {
  deleteProject(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const ArchiveProjectDocument = new TypedDocumentString(`
    mutation ArchiveProject($id: ID!) {
  archiveProject(id: $id) {
    id
    archiveStatus
    archiveRequestedAt
  }
}
    `) as unknown as TypedDocumentString<ArchiveProjectMutation, ArchiveProjectMutationVariables>;
export const RestoreProjectDocument = new TypedDocumentString(`
    mutation RestoreProject($id: ID!) {
  restoreProject(id: $id) {
    id
    archiveStatus
    restoreRequestedAt
    restoreExpiresAt
  }
}
    `) as unknown as TypedDocumentString<RestoreProjectMutation, RestoreProjectMutationVariables>;
export const DeleteArchivedProjectDocument = new TypedDocumentString(`
    mutation DeleteArchivedProject($id: ID!) {
  deleteArchivedProject(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteArchivedProjectMutation, DeleteArchivedProjectMutationVariables>;
export const AddProjectBaseMapDocument = new TypedDocumentString(`
    mutation AddProjectBaseMap($projectId: ID!, $input: CustomBaseMapInput!) {
  addProjectBaseMap(projectId: $projectId, input: $input) {
    id
    baseMaps {
      id
      name
      type
      url
      tileSize
      wmsVersion
      wmsLayers
      format
    }
  }
}
    `) as unknown as TypedDocumentString<AddProjectBaseMapMutation, AddProjectBaseMapMutationVariables>;
export const UpdateProjectBaseMapDocument = new TypedDocumentString(`
    mutation UpdateProjectBaseMap($projectId: ID!, $baseMapId: ID!, $input: CustomBaseMapInput!) {
  updateProjectBaseMap(
    projectId: $projectId
    baseMapId: $baseMapId
    input: $input
  ) {
    id
    baseMaps {
      id
      name
      type
      url
      tileSize
      wmsVersion
      wmsLayers
      format
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateProjectBaseMapMutation, UpdateProjectBaseMapMutationVariables>;
export const DeleteProjectBaseMapDocument = new TypedDocumentString(`
    mutation DeleteProjectBaseMap($projectId: ID!, $baseMapId: ID!) {
  deleteProjectBaseMap(projectId: $projectId, baseMapId: $baseMapId) {
    id
    baseMaps {
      id
      name
      type
      url
      tileSize
      wmsVersion
      wmsLayers
      format
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteProjectBaseMapMutation, DeleteProjectBaseMapMutationVariables>;
export const CreateReferralDocument = new TypedDocumentString(`
    mutation CreateReferral($email: String!, $message: String) {
  createReferral(email: $email, message: $message) {
    id
    referredEmail
    token
    accountCreatedAt
    organizationCreatedAt
    subscriptionStartedAt
    expiresAt
    createdAt
  }
}
    `) as unknown as TypedDocumentString<CreateReferralMutation, CreateReferralMutationVariables>;
export const DeleteReferralDocument = new TypedDocumentString(`
    mutation DeleteReferral($id: ID!) {
  deleteReferral(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteReferralMutation, DeleteReferralMutationVariables>;
export const CreateSavedViewDocument = new TypedDocumentString(`
    mutation CreateSavedView($input: CreateSavedViewInput!) {
  createSavedView(input: $input) {
    id
    projectId
    name
    description
    visibility
    camera
    clipBox
    visibleLayerIds
    baseMapId
    createdById
    createdAt
    updatedAt
    createdBy {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<CreateSavedViewMutation, CreateSavedViewMutationVariables>;
export const UpdateSavedViewDocument = new TypedDocumentString(`
    mutation UpdateSavedView($input: UpdateSavedViewInput!) {
  updateSavedView(input: $input) {
    id
    projectId
    name
    description
    visibility
    camera
    clipBox
    visibleLayerIds
    baseMapId
    createdById
    createdAt
    updatedAt
    createdBy {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateSavedViewMutation, UpdateSavedViewMutationVariables>;
export const DeleteSavedViewDocument = new TypedDocumentString(`
    mutation DeleteSavedView($id: ID!) {
  deleteSavedView(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteSavedViewMutation, DeleteSavedViewMutationVariables>;
export const CreateSubscriptionDocument = new TypedDocumentString(`
    mutation CreateSubscription($input: CreateSubscriptionInput!) {
  createSubscription(input: $input) {
    type
    url
  }
}
    `) as unknown as TypedDocumentString<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const ChangeSubscriptionPlanDocument = new TypedDocumentString(`
    mutation ChangeSubscriptionPlan($input: ChangePlanInput!) {
  changeSubscriptionPlan(input: $input)
}
    `) as unknown as TypedDocumentString<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>;
export const CancelSubscriptionDocument = new TypedDocumentString(`
    mutation CancelSubscription($organizationId: ID!) {
  cancelSubscription(organizationId: $organizationId)
}
    `) as unknown as TypedDocumentString<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const ReactivateSubscriptionDocument = new TypedDocumentString(`
    mutation ReactivateSubscription($organizationId: ID!) {
  reactivateSubscription(organizationId: $organizationId)
}
    `) as unknown as TypedDocumentString<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>;
export const ApplySubscriptionDiscountDocument = new TypedDocumentString(`
    mutation ApplySubscriptionDiscount($input: ApplyDiscountInput!) {
  applySubscriptionDiscount(input: $input)
}
    `) as unknown as TypedDocumentString<ApplySubscriptionDiscountMutation, ApplySubscriptionDiscountMutationVariables>;
export const RemoveSubscriptionDiscountDocument = new TypedDocumentString(`
    mutation RemoveSubscriptionDiscount($organizationId: ID!) {
  removeSubscriptionDiscount(organizationId: $organizationId)
}
    `) as unknown as TypedDocumentString<RemoveSubscriptionDiscountMutation, RemoveSubscriptionDiscountMutationVariables>;
export const CreateBillingPortalSessionDocument = new TypedDocumentString(`
    mutation CreateBillingPortalSession($organizationId: ID!, $returnUrl: String!) {
  createBillingPortalSession(
    organizationId: $organizationId
    returnUrl: $returnUrl
  )
}
    `) as unknown as TypedDocumentString<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>;
export const UpdateUserDocument = new TypedDocumentString(`
    mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
  updateUser(id: $id, input: $input) {
    id
    name
    mobileNumber
    avatar {
      id
      url
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdatePasswordDocument = new TypedDocumentString(`
    mutation UpdatePassword($id: ID!, $input: UpdatePasswordInput!) {
  updatePassword(id: $id, input: $input)
}
    `) as unknown as TypedDocumentString<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const DeleteUserDocument = new TypedDocumentString(`
    mutation DeleteUser($id: ID!, $password: String!) {
  deleteUser(id: $id, password: $password)
}
    `) as unknown as TypedDocumentString<DeleteUserMutation, DeleteUserMutationVariables>;
export const UpdateEmailDocument = new TypedDocumentString(`
    mutation UpdateEmail($id: ID!, $email: String!) {
  updateEmail(id: $id, email: $email)
}
    `) as unknown as TypedDocumentString<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const RevokeSessionDocument = new TypedDocumentString(`
    mutation RevokeSession($sessionId: ID!) {
  revokeSession(sessionId: $sessionId)
}
    `) as unknown as TypedDocumentString<RevokeSessionMutation, RevokeSessionMutationVariables>;
export const UpdateThemeDocument = new TypedDocumentString(`
    mutation UpdateTheme($theme: ThemePreference!) {
  updateTheme(theme: $theme)
}
    `) as unknown as TypedDocumentString<UpdateThemeMutation, UpdateThemeMutationVariables>;
export const UpdateLanguageDocument = new TypedDocumentString(`
    mutation UpdateLanguage($language: String) {
  updateLanguage(language: $language)
}
    `) as unknown as TypedDocumentString<UpdateLanguageMutation, UpdateLanguageMutationVariables>;
export const UpdateViewerSettingsDocument = new TypedDocumentString(`
    mutation UpdateViewerSettings($input: ViewerSettingsInput!) {
  updateViewerSettings(input: $input)
}
    `) as unknown as TypedDocumentString<UpdateViewerSettingsMutation, UpdateViewerSettingsMutationVariables>;
export const SaveOnboardingSurveyDocument = new TypedDocumentString(`
    mutation SaveOnboardingSurvey($data: JSON!) {
  saveOnboardingSurvey(data: $data)
}
    `) as unknown as TypedDocumentString<SaveOnboardingSurveyMutation, SaveOnboardingSurveyMutationVariables>;
export const SetupTwoFactorDocument = new TypedDocumentString(`
    mutation SetupTwoFactor($mobileNumber: String!) {
  setupTwoFactor(mobileNumber: $mobileNumber) {
    secret
  }
}
    `) as unknown as TypedDocumentString<SetupTwoFactorMutation, SetupTwoFactorMutationVariables>;
export const VerifyTwoFactorSetupDocument = new TypedDocumentString(`
    mutation VerifyTwoFactorSetup($secret: String!, $code: String!) {
  verifyTwoFactorSetup(secret: $secret, code: $code)
}
    `) as unknown as TypedDocumentString<VerifyTwoFactorSetupMutation, VerifyTwoFactorSetupMutationVariables>;
export const SetupAuthenticatorTwoFactorDocument = new TypedDocumentString(`
    mutation SetupAuthenticatorTwoFactor {
  setupAuthenticatorTwoFactor {
    secret
    otpauthUri
  }
}
    `) as unknown as TypedDocumentString<SetupAuthenticatorTwoFactorMutation, SetupAuthenticatorTwoFactorMutationVariables>;
export const VerifyAuthenticatorTwoFactorSetupDocument = new TypedDocumentString(`
    mutation VerifyAuthenticatorTwoFactorSetup($secret: String!, $code: String!) {
  verifyAuthenticatorTwoFactorSetup(secret: $secret, code: $code)
}
    `) as unknown as TypedDocumentString<VerifyAuthenticatorTwoFactorSetupMutation, VerifyAuthenticatorTwoFactorSetupMutationVariables>;
export const DisableTwoFactorDocument = new TypedDocumentString(`
    mutation DisableTwoFactor($secret: String!, $code: String!) {
  disableTwoFactor(secret: $secret, code: $code)
}
    `) as unknown as TypedDocumentString<DisableTwoFactorMutation, DisableTwoFactorMutationVariables>;
export const DisableAuthenticatorTwoFactorDocument = new TypedDocumentString(`
    mutation DisableAuthenticatorTwoFactor($code: String!) {
  disableAuthenticatorTwoFactor(code: $code)
}
    `) as unknown as TypedDocumentString<DisableAuthenticatorTwoFactorMutation, DisableAuthenticatorTwoFactorMutationVariables>;
export const GetAttachmentsDocument = new TypedDocumentString(`
    query GetAttachments {
  attachments {
    id
    url
    s3Key
    uploadId
    filename
    contentType
    contentLength
    checksumSHA256Base64
    status
    createdAt
    updatedAt
    deletedAt
    organizationId
    projectId
  }
}
    `) as unknown as TypedDocumentString<GetAttachmentsQuery, GetAttachmentsQueryVariables>;
export const GetAttachmentsByBatchDocument = new TypedDocumentString(`
    query GetAttachmentsByBatch($batchId: ID!) {
  attachmentsByBatch(batchId: $batchId) {
    id
    url
    s3Key
    uploadId
    filename
    contentType
    contentLength
    checksumSHA256Base64
    status
    createdAt
    updatedAt
    organizationId
    projectId
  }
}
    `) as unknown as TypedDocumentString<GetAttachmentsByBatchQuery, GetAttachmentsByBatchQueryVariables>;
export const StartUploadDocument = new TypedDocumentString(`
    mutation StartUpload($project: ID!, $filename: String!, $contentType: String!, $checksumSHA256Base64: String, $batch: ID) {
  attachment: startUpload(
    project: $project
    filename: $filename
    contentType: $contentType
    checksumSHA256Base64: $checksumSHA256Base64
    batch: $batch
  ) {
    id
    url
    s3Key
    uploadId
    batchId
    filename
    contentType
    contentLength
    checksumSHA256Base64
    status
    createdAt
    updatedAt
    organizationId
    projectId
  }
}
    `) as unknown as TypedDocumentString<StartUploadMutation, StartUploadMutationVariables>;
export const StartUploadBatchDocument = new TypedDocumentString(`
    mutation StartUploadBatch($project: ID!, $numberOfAttachments: Int!, $label: String) {
  batch: startBatch(
    project: $project
    numberOfAttachments: $numberOfAttachments
    label: $label
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<StartUploadBatchMutation, StartUploadBatchMutationVariables>;
export const CompleteUploadBatchDocument = new TypedDocumentString(`
    mutation CompleteUploadBatch($id: ID!) {
  success: completeBatch(id: $id)
}
    `) as unknown as TypedDocumentString<CompleteUploadBatchMutation, CompleteUploadBatchMutationVariables>;
export const UploadPartDocument = new TypedDocumentString(`
    mutation UploadPart($attachmentId: ID!, $partNumber: Int!, $contentLength: Int!, $checksumSHA256Base64: String!) {
  url: uploadPart(
    attachmentId: $attachmentId
    partNumber: $partNumber
    contentLength: $contentLength
    checksumSHA256Base64: $checksumSHA256Base64
  )
}
    `) as unknown as TypedDocumentString<UploadPartMutation, UploadPartMutationVariables>;
export const CompleteUploadDocument = new TypedDocumentString(`
    mutation CompleteUpload($attachmentId: ID!, $parts: [S3CompletedPart!]!) {
  attachment: completeUpload(attachmentId: $attachmentId, parts: $parts) {
    id
    url
    s3Key
    uploadId
    filename
    contentType
    contentLength
    checksumSHA256Base64
    status
    createdAt
    updatedAt
    organizationId
    projectId
  }
}
    `) as unknown as TypedDocumentString<CompleteUploadMutation, CompleteUploadMutationVariables>;
export const AbortUploadDocument = new TypedDocumentString(`
    mutation AbortUpload($attachmentId: ID!) {
  success: abortUpload(attachmentId: $attachmentId)
}
    `) as unknown as TypedDocumentString<AbortUploadMutation, AbortUploadMutationVariables>;
export const StartBatchDocument = new TypedDocumentString(`
    mutation StartBatch($project: ID!, $numberOfAttachments: Int!, $label: String) {
  batch: startBatch(
    project: $project
    numberOfAttachments: $numberOfAttachments
    label: $label
  ) {
    id
    status
    createdAt
    createdById
    numberOfAttachments
    processingStartedAt
    processingCompletedAt
    srid
  }
}
    `) as unknown as TypedDocumentString<StartBatchMutation, StartBatchMutationVariables>;
export const CompleteBatchDocument = new TypedDocumentString(`
    mutation CompleteBatch($id: ID!) {
  success: completeBatch(id: $id)
}
    `) as unknown as TypedDocumentString<CompleteBatchMutation, CompleteBatchMutationVariables>;
export const GetBatchesDocument = new TypedDocumentString(`
    query GetBatches($projectId: ID!) {
  batches(projectId: $projectId) {
    id
    key
    label
    kind
    status
    createdAt
    numberOfAttachments
    processingStartedAt
    processingCompletedAt
    srid
    createdBy {
      id
      name
      email
      avatar {
        id
        url
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetBatchesQuery, GetBatchesQueryVariables>;
export const GetBatchDocument = new TypedDocumentString(`
    query GetBatch($id: ID!) {
  batch(id: $id) {
    id
    key
    label
    kind
    status
    createdAt
    createdById
    createdBy {
      id
      name
      email
      avatar {
        id
        url
      }
    }
    srid
    numberOfAttachments
    processingStartedAt
    processingCompletedAt
    totalBytes
    attachments {
      id
      url
      s3Key
      filename
      contentType
      contentLength
      byproducts {
        id
        filename
        type
        contentLength
        downloadUrl
        expiresAt
        isInternal
      }
    }
    byproducts {
      id
      filename
      type
      contentLength
      downloadUrl
      expiresAt
      isInternal
      sourceAttachmentId
      processJobId
      createdAt
    }
    jobs {
      id
      type
      status
      inputJson
      outputJson
      leaseUntil
      attempts
      isLeaf
      batchId
      parentItemId
      label
      logs
      logStream
      errorLogs
      startedAt
      completedAt
      estimatedCompletion
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<GetBatchQuery, GetBatchQueryVariables>;
export const StartBatchProcessingDocument = new TypedDocumentString(`
    mutation StartBatchProcessing($id: ID!, $srid: Int!, $type: ProcessJobType!, $dxfOutputVersion: String, $minZoom: Int, $maxZoom: Int, $tileSize: Int, $pointCloudAttributes: [String!], $compressImages: Boolean, $blurLicensePlates: Boolean, $blurFaces: Boolean, $generateRcs: Boolean, $generateDecimatedPointCloud: Boolean, $generateGeotiff: Boolean, $importUrl: String, $rasterMode: String) {
  success: startBatchProcessing(
    id: $id
    srid: $srid
    type: $type
    dxfOutputVersion: $dxfOutputVersion
    minZoom: $minZoom
    maxZoom: $maxZoom
    tileSize: $tileSize
    pointCloudAttributes: $pointCloudAttributes
    compressImages: $compressImages
    blurLicensePlates: $blurLicensePlates
    blurFaces: $blurFaces
    generateRcs: $generateRcs
    generateDecimatedPointCloud: $generateDecimatedPointCloud
    generateGeotiff: $generateGeotiff
    importUrl: $importUrl
    rasterMode: $rasterMode
  )
}
    `) as unknown as TypedDocumentString<StartBatchProcessingMutation, StartBatchProcessingMutationVariables>;
export const CreateAttachmentDocument = new TypedDocumentString(`
    mutation CreateAttachment($project: ID, $filename: String!, $contentType: String!, $checksumSHA256Base64: String, $type: UploadType!) {
  createAttachment(
    project: $project
    filename: $filename
    contentType: $contentType
    checksumSHA256Base64: $checksumSHA256Base64
    type: $type
  ) {
    attachment {
      id
      url
      s3Key
      uploadId
      batchId
      filename
      contentType
      contentLength
      checksumSHA256Base64
      status
      createdAt
      updatedAt
      organizationId
      projectId
    }
    uploadUrl
  }
}
    `) as unknown as TypedDocumentString<CreateAttachmentMutation, CreateAttachmentMutationVariables>;
export const DeleteAttachmentDocument = new TypedDocumentString(`
    mutation DeleteAttachment($attachmentId: ID!) {
  success: deleteAttachment(attachmentId: $attachmentId)
}
    `) as unknown as TypedDocumentString<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;
export const DeleteBatchDocument = new TypedDocumentString(`
    mutation DeleteBatch($id: ID!) {
  success: deleteBatch(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteBatchMutation, DeleteBatchMutationVariables>;
export const ResetBatchDocument = new TypedDocumentString(`
    mutation ResetBatch($id: ID!) {
  success: resetBatch(id: $id)
}
    `) as unknown as TypedDocumentString<ResetBatchMutation, ResetBatchMutationVariables>;
export const LayerByproductsDocument = new TypedDocumentString(`
    query LayerByproducts($layerId: ID!) {
  layerByproducts(layerId: $layerId) {
    id
    filename
    type
    contentLength
    downloadUrl
    processJobId
    createdAt
  }
}
    `) as unknown as TypedDocumentString<LayerByproductsQuery, LayerByproductsQueryVariables>;
export const BatchByproductsDocument = new TypedDocumentString(`
    query BatchByproducts($id: ID!) {
  batch(id: $id) {
    id
    byproducts {
      id
      filename
      downloadUrl
      processJobId
    }
  }
}
    `) as unknown as TypedDocumentString<BatchByproductsQuery, BatchByproductsQueryVariables>;
export const ClearanceProfilesDocument = new TypedDocumentString(`
    query ClearanceProfiles {
  clearanceProfiles {
    id
    name
    sourceAttribution
    vertices
    createdById
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<ClearanceProfilesQuery, ClearanceProfilesQueryVariables>;
export const SaveClearanceProfileDocument = new TypedDocumentString(`
    mutation SaveClearanceProfile($input: SaveClearanceProfileInput!) {
  saveClearanceProfile(input: $input) {
    id
    name
    sourceAttribution
    vertices
    createdById
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<SaveClearanceProfileMutation, SaveClearanceProfileMutationVariables>;
export const DeleteClearanceProfileDocument = new TypedDocumentString(`
    mutation DeleteClearanceProfile($id: ID!) {
  deleteClearanceProfile(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteClearanceProfileMutation, DeleteClearanceProfileMutationVariables>;
export const StartClearanceDocument = new TypedDocumentString(`
    mutation StartClearance($input: StartClearanceInput!) {
  startClearance(input: $input)
}
    `) as unknown as TypedDocumentString<StartClearanceMutation, StartClearanceMutationVariables>;
export const StartClipboxExportDocument = new TypedDocumentString(`
    mutation StartClipboxExport($input: StartClipboxExportInput!) {
  startClipboxExport(input: $input)
}
    `) as unknown as TypedDocumentString<StartClipboxExportMutation, StartClipboxExportMutationVariables>;
export const DashboardStatsDocument = new TypedDocumentString(`
    query DashboardStats {
  dashboardStats {
    projects {
      id
      name
      storageUsedBytes
      positionWGS84
      createdAt
      layerCounts {
        type
        count
      }
    }
    layerTypeCounts {
      type
      count
    }
    totalLayers
  }
}
    `) as unknown as TypedDocumentString<DashboardStatsQuery, DashboardStatsQueryVariables>;
export const SharedLinkDashboardDocument = new TypedDocumentString(`
    query SharedLinkDashboard {
  sharedLinkDashboard {
    dailyViews {
      date
      count
    }
    topProjectsByLinks {
      projectId
      projectName
      linkCount
    }
    topLinksByViews {
      id
      name
      projectName
      viewCount
    }
    totalLinks
  }
}
    `) as unknown as TypedDocumentString<SharedLinkDashboardQuery, SharedLinkDashboardQueryVariables>;
export const StartDeviationAnalysisDocument = new TypedDocumentString(`
    mutation StartDeviationAnalysis($input: StartDeviationAnalysisInput!) {
  startDeviationAnalysis(input: $input)
}
    `) as unknown as TypedDocumentString<StartDeviationAnalysisMutation, StartDeviationAnalysisMutationVariables>;
export const DeviationJobsDocument = new TypedDocumentString(`
    query DeviationJobs($projectId: ID!) {
  deviationJobs(projectId: $projectId) {
    id
    status
    label
    batchId
    inputJson
    outputJson
    errorLogs
    createdAt
    startedAt
    completedAt
  }
}
    `) as unknown as TypedDocumentString<DeviationJobsQuery, DeviationJobsQueryVariables>;
export const FeaturesDocument = new TypedDocumentString(`
    query features($layerIds: [ID!]!) {
  featuresByLayer(layerIds: $layerIds) {
    id
    serial
    layerId
    geometryWGS84
    geometry
    properties
  }
}
    `) as unknown as TypedDocumentString<FeaturesQuery, FeaturesQueryVariables>;
export const FeaturesByProjectDocument = new TypedDocumentString(`
    query FeaturesByProject($projectId: ID!) {
  features(projectId: $projectId) {
    id
    serial
    layerId
    geometryWGS84
    geometry
    properties
  }
}
    `) as unknown as TypedDocumentString<FeaturesByProjectQuery, FeaturesByProjectQueryVariables>;
export const FeatureDocument = new TypedDocumentString(`
    query Feature($id: ID!) {
  feature(id: $id) {
    id
    serial
    layerId
    geometryWGS84
    geometry
    properties
  }
}
    `) as unknown as TypedDocumentString<FeatureQuery, FeatureQueryVariables>;
export const CreateFeatureDocument = new TypedDocumentString(`
    mutation CreateFeature($input: CreateFeatureInput!) {
  createFeature(input: $input) {
    id
    serial
    layerId
    geometryWGS84
    geometry
    properties
  }
}
    `) as unknown as TypedDocumentString<CreateFeatureMutation, CreateFeatureMutationVariables>;
export const UpdateFeatureDocument = new TypedDocumentString(`
    mutation UpdateFeature($input: UpdateFeatureInput!) {
  updateFeature(input: $input) {
    id
    serial
    layerId
    geometryWGS84
    geometry
    properties
  }
}
    `) as unknown as TypedDocumentString<UpdateFeatureMutation, UpdateFeatureMutationVariables>;
export const FeaturesByIdsDocument = new TypedDocumentString(`
    query FeaturesByIds($ids: [ID!]!) {
  featuresByIds(ids: $ids) {
    id
    serial
    layerId
    properties
  }
}
    `) as unknown as TypedDocumentString<FeaturesByIdsQuery, FeaturesByIdsQueryVariables>;
export const UpdateFeaturesDocument = new TypedDocumentString(`
    mutation UpdateFeatures($input: [UpdateFeatureInput!]!) {
  updateFeatures(input: $input) {
    id
    serial
    layerId
    properties
  }
}
    `) as unknown as TypedDocumentString<UpdateFeaturesMutation, UpdateFeaturesMutationVariables>;
export const DeleteFeatureDocument = new TypedDocumentString(`
    mutation DeleteFeature($id: ID!) {
  deleteFeature(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteFeatureMutation, DeleteFeatureMutationVariables>;
export const DeleteFeaturesDocument = new TypedDocumentString(`
    mutation DeleteFeatures($ids: [ID!]!) {
  deleteFeatures(ids: $ids)
}
    `) as unknown as TypedDocumentString<DeleteFeaturesMutation, DeleteFeaturesMutationVariables>;
export const SridsDocument = new TypedDocumentString(`
    query Srids {
  srids {
    srid
    name
    projection
  }
}
    `) as unknown as TypedDocumentString<SridsQuery, SridsQueryVariables>;
export const FeaturesPaginatedDocument = new TypedDocumentString(`
    query featuresPaginated($projectId: ID!, $layerId: ID, $cursor: String, $orderBy: FeatureOrder, $limit: Int!, $filters: [FeatureFilter!], $query: String) {
  featuresPaginated(
    limit: $limit
    projectId: $projectId
    layerId: $layerId
    cursor: $cursor
    orderBy: $orderBy
    filters: $filters
    query: $query
  ) {
    features {
      id
      serial
      properties
      layerId
    }
    total
    cursor
  }
}
    `) as unknown as TypedDocumentString<FeaturesPaginatedQuery, FeaturesPaginatedQueryVariables>;
export const FeatureSummaryDocument = new TypedDocumentString(`
    query FeatureSummary($layerId: ID!, $filters: [FeatureFilter!], $query: String) {
  featureSummary(layerId: $layerId, filters: $filters, query: $query) {
    pointCount
    lineCount
    polygonCount
    totalLineLengthM
    totalPolygonAreaSqm
    totalPolygonPerimeterM
  }
}
    `) as unknown as TypedDocumentString<FeatureSummaryQuery, FeatureSummaryQueryVariables>;
export const FeatureAttachmentsDocument = new TypedDocumentString(`
    query FeatureAttachments($featureId: ID!) {
  featureAttachments(featureId: $featureId) {
    id
    label
    uploadedById
    attachmentId
    attachment {
      id
      url
      filename
      contentType
      contentLength
    }
    uploadedBy {
      id
      name
      email
      avatar {
        url
      }
    }
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<FeatureAttachmentsQuery, FeatureAttachmentsQueryVariables>;
export const CreateFeatureAttachmentDocument = new TypedDocumentString(`
    mutation CreateFeatureAttachment($input: CreateFeatureAttachmentInput!) {
  createFeatureAttachment(input: $input) {
    id
    label
    uploadedById
    attachmentId
    attachment {
      id
      url
      filename
      contentType
      contentLength
    }
    createdAt
  }
}
    `) as unknown as TypedDocumentString<CreateFeatureAttachmentMutation, CreateFeatureAttachmentMutationVariables>;
export const DeleteFeatureAttachmentDocument = new TypedDocumentString(`
    mutation DeleteFeatureAttachment($id: ID!) {
  deleteFeatureAttachment(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteFeatureAttachmentMutation, DeleteFeatureAttachmentMutationVariables>;
export const DownloadFeaturesDocument = new TypedDocumentString(`
    mutation DownloadFeatures($ids: [ID!], $layerId: ID, $exportType: ExportType!) {
  downloadFeatures(ids: $ids, layerId: $layerId, exportType: $exportType)
}
    `) as unknown as TypedDocumentString<DownloadFeaturesMutation, DownloadFeaturesMutationVariables>;
export const GoogleImagesByPositionDocument = new TypedDocumentString(`
    query GoogleImagesByPosition($lat: Float!, $lng: Float!) {
  images: googleImagesByPosition(lat: $lat, lng: $lng) {
    id
    panoId
    root
    heading
    roll
    tilt
    width
    height
    copyright
    date
    locationWGS84
    createdAt
  }
}
    `) as unknown as TypedDocumentString<GoogleImagesByPositionQuery, GoogleImagesByPositionQueryVariables>;
export const StartGroundClassificationDocument = new TypedDocumentString(`
    mutation StartGroundClassification($input: StartGroundClassificationInput!) {
  startGroundClassification(input: $input)
}
    `) as unknown as TypedDocumentString<StartGroundClassificationMutation, StartGroundClassificationMutationVariables>;
export const ImagesDocument = new TypedDocumentString(`
    query images($layerIds: [ID!]!) {
  imagesByLayer(layerIds: $layerIds) {
    id
    organizationId
    projectId
    attachmentId
    layerId
    locationWGS84
    location
    groupId
    width
    height
    pixelWidth
    pixelHeight
    focalLengthX
    focalLengthY
    principalPointX
    principalPointY
    rotationMatrix
    rotationQuaternion
    filename
    cameraType
    k1
    k2
    k3
    k4
    p1
    p2
    hasCompressedVariants
    smallFilename
    largeFilename
    hasBlurredVariants
    blurredFilename
    smallBlurredFilename
    largeBlurredFilename
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<ImagesQuery, ImagesQueryVariables>;
export const StartLandxmlExportDocument = new TypedDocumentString(`
    mutation StartLandxmlExport($input: StartLandxmlExportInput!) {
  startLandxmlExport(input: $input)
}
    `) as unknown as TypedDocumentString<StartLandxmlExportMutation, StartLandxmlExportMutationVariables>;
export const LayersDocument = new TypedDocumentString(`
    query Layers($projectId: ID!) {
  layers(projectId: $projectId) {
    id
    parentLayerId
    name
    description
    type
    root
    metadata
    bbox
    bboxNew
    center
    isHidden
    isLocked
    isEphemeral
    ephemeralExpiresAt
    ephemeralSourceBytes
    propertyAliases {
      property
      alias
    }
    createdAt
    updatedAt
    settings {
      pointCloudMaterialColorSource
      pointCloudMaterialColor
      pointCloudFixedColor
      modelIsWireframe
      modelDefaultColor
      modelOpacity
      modelColorBy
      modelClassColors {
        class
        color
      }
      landxmlCategoryColors {
        surface
        alignment
        parcel
        breakline
        pipe
        structure
      }
      landxmlSurfaceColorMode
      landxmlSurfaceColormap
      surfaceDifferenceColormap
      scalarRangeMin
      scalarRangeMax
      pointCloudClasses {
        color
        isEnabled
      }
      imagePointColor
      vectorDefaultColor
      vectorDefaultOpacity
      vectorIsWireframe
      vectorDefaultPointSize
      vectorLineRenderAsPipe
      vectorLineWidth
      rasterOpacity
      rasterContrast
      rasterSaturation
      rasterBrightness
      offsetX
      offsetY
      offsetZ
      rotationX
      rotationY
      rotationZ
      sectionOverlays {
        id
        kind
        layerId
        ref
        pcMethod
        hidden
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LayersQuery, LayersQueryVariables>;
export const CreateLayerDocument = new TypedDocumentString(`
    mutation CreateLayer($input: CreateLayerInput!) {
  createLayer(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateLayerMutation, CreateLayerMutationVariables>;
export const UpdateLayerDocument = new TypedDocumentString(`
    mutation UpdateLayer($input: UpdateLayerInput!) {
  updateLayer(input: $input) {
    id
    name
    description
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<UpdateLayerMutation, UpdateLayerMutationVariables>;
export const DeleteLayerDocument = new TypedDocumentString(`
    mutation DeleteLayer($id: ID!) {
  deleteLayer(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteLayerMutation, DeleteLayerMutationVariables>;
export const LayerDocument = new TypedDocumentString(`
    query Layer($id: ID!) {
  layer(id: $id) {
    id
    parentLayerId
    name
    description
    type
    root
    metadata
    bbox
    bboxNew
    center
    isHidden
    isLocked
    createdAt
    updatedAt
    sourceAttachment {
      batchId
      filename
      contentLength
      createdAt
    }
    settings {
      pointCloudMaterialColorSource
      pointCloudMaterialColor
      pointCloudFixedColor
      modelIsWireframe
      modelDefaultColor
      modelOpacity
      modelColorBy
      modelClassColors {
        class
        color
      }
      landxmlCategoryColors {
        surface
        alignment
        parcel
        breakline
        pipe
        structure
      }
      landxmlSurfaceColorMode
      landxmlSurfaceColormap
      surfaceDifferenceColormap
      scalarRangeMin
      scalarRangeMax
      pointCloudClasses {
        color
        isEnabled
      }
      imagePointColor
      imageBrightness
      imageContrast
      imageSaturation
      imageOpacity
      vectorDefaultColor
      vectorDefaultOpacity
      vectorIsWireframe
      vectorDefaultPointSize
      vectorLineRenderAsPipe
      vectorLineWidth
      rasterOpacity
      rasterContrast
      rasterSaturation
      rasterBrightness
      offsetX
      offsetY
      offsetZ
      rotationX
      rotationY
      rotationZ
      sectionOverlays {
        id
        kind
        layerId
        ref
        pcMethod
        hidden
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LayerQuery, LayerQueryVariables>;
export const UpdateLayerSettingsDocument = new TypedDocumentString(`
    mutation UpdateLayerSettings($id: ID!, $input: LayerSettingsInput!) {
  updateLayerSettings(id: $id, input: $input)
}
    `) as unknown as TypedDocumentString<UpdateLayerSettingsMutation, UpdateLayerSettingsMutationVariables>;
export const UpdateLayersSettingsDocument = new TypedDocumentString(`
    mutation UpdateLayersSettings($input: [UpdateLayerSettingsBatchInput!]!) {
  updateLayersSettings(input: $input)
}
    `) as unknown as TypedDocumentString<UpdateLayersSettingsMutation, UpdateLayersSettingsMutationVariables>;
export const LayerSettingsDocument = new TypedDocumentString(`
    query LayerSettings($id: ID!) {
  layer(id: $id) {
    id
    settings {
      pointCloudMaterialColorSource
      pointCloudMaterialColor
      pointCloudFixedColor
      modelIsWireframe
      modelDefaultColor
      modelOpacity
      modelColorBy
      modelClassColors {
        class
        color
      }
      landxmlCategoryColors {
        surface
        alignment
        parcel
        breakline
        pipe
        structure
      }
      landxmlSurfaceColorMode
      landxmlSurfaceColormap
      surfaceDifferenceColormap
      scalarRangeMin
      scalarRangeMax
      pointCloudClasses {
        color
        isEnabled
      }
      imagePointColor
      imageBrightness
      imageContrast
      imageSaturation
      imageOpacity
      vectorDefaultColor
      vectorDefaultOpacity
      vectorIsWireframe
      vectorDefaultPointSize
      vectorLineRenderAsPipe
      vectorLineWidth
      rasterOpacity
      rasterContrast
      rasterSaturation
      rasterBrightness
      offsetX
      offsetY
      offsetZ
      rotationX
      rotationY
      rotationZ
      sectionOverlays {
        id
        kind
        layerId
        ref
        pcMethod
        hidden
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LayerSettingsQuery, LayerSettingsQueryVariables>;
export const LayerPropertiesDocument = new TypedDocumentString(`
    query LayerProperties($layerId: ID!) {
  layerProperties(layerId: $layerId)
}
    `) as unknown as TypedDocumentString<LayerPropertiesQuery, LayerPropertiesQueryVariables>;
export const LayerPropertyValuesDocument = new TypedDocumentString(`
    query LayerPropertyValues($layerId: ID!) {
  layerPropertyValues(layerId: $layerId) {
    property
    values
  }
}
    `) as unknown as TypedDocumentString<LayerPropertyValuesQuery, LayerPropertyValuesQueryVariables>;
export const QuickUploadLayerDocument = new TypedDocumentString(`
    mutation QuickUploadLayer($input: QuickUploadLayerInput!) {
  quickUploadLayer(input: $input) {
    layer {
      id
      name
      type
      isEphemeral
      ephemeralExpiresAt
      ephemeralSourceBytes
    }
    expiresAt
  }
}
    `) as unknown as TypedDocumentString<QuickUploadLayerMutation, QuickUploadLayerMutationVariables>;
export const TouchEphemeralLayersDocument = new TypedDocumentString(`
    mutation TouchEphemeralLayers($layerIds: [ID!]!) {
  touchEphemeralLayers(layerIds: $layerIds)
}
    `) as unknown as TypedDocumentString<TouchEphemeralLayersMutation, TouchEphemeralLayersMutationVariables>;
export const RefreshWmsLayerDocument = new TypedDocumentString(`
    mutation RefreshWmsLayer($layerId: ID!) {
  refreshWmsLayer(layerId: $layerId) {
    id
    name
    type
    metadata
    subLayers {
      id
      name
      type
      metadata
      bbox
      isHidden
    }
  }
}
    `) as unknown as TypedDocumentString<RefreshWmsLayerMutation, RefreshWmsLayerMutationVariables>;
export const MaterializeSectionOverlaysDocument = new TypedDocumentString(`
    mutation MaterializeSectionOverlays($layerId: ID!) {
  materializeSectionOverlays(layerId: $layerId)
}
    `) as unknown as TypedDocumentString<MaterializeSectionOverlaysMutation, MaterializeSectionOverlaysMutationVariables>;
export const StartLayerStackDocument = new TypedDocumentString(`
    mutation StartLayerStack($input: StartLayerStackInput!) {
  startLayerStack(input: $input)
}
    `) as unknown as TypedDocumentString<StartLayerStackMutation, StartLayerStackMutationVariables>;
export const MeDocument = new TypedDocumentString(`
    query Me {
  me {
    id
    firstName
    lastName
    name
    email
    mobileNumber
    avatarId
    onboardingSurveyCompleted
    onboardingTourCompleted
    twoFactorEnabled
    twoFactorType
    theme
    language
    isReferrer
    avatar {
      url
    }
    featurebaseUser {
      organization
      email
      name
      userId
      profilePicture
      featurebaseJwt
    }
    viewerSettings {
      pointCloudPointSizeType
      pointCloudPointSize
      orthoPointSize
      pointCloudLoadingDistance
      pointCloudMinNodePixelSize
      pointCloudPointBudget
      showLayerSource
      showLayerUnderType
      showImagePOIs
      showAllImagePOIs
      imagePOIMaxDistance
      showPointCloudBoundingBoxes
      showOrthoGrid
      googleStreetViewPoiColor
      backgroundColor
      actionPosition
      customBaseMaps {
        id
        name
        type
        url
        tileSize
        wmsVersion
        wmsLayers
        format
      }
    }
  }
}
    `) as unknown as TypedDocumentString<MeQuery, MeQueryVariables>;
export const UserPasskeysDocument = new TypedDocumentString(`
    query UserPasskeys {
  userPasskeys {
    id
    name
    createdAt
    lastUsedAt
  }
}
    `) as unknown as TypedDocumentString<UserPasskeysQuery, UserPasskeysQueryVariables>;
export const RenamePasskeyDocument = new TypedDocumentString(`
    mutation RenamePasskey($id: ID!, $name: String!) {
  renamePasskey(id: $id, name: $name)
}
    `) as unknown as TypedDocumentString<RenamePasskeyMutation, RenamePasskeyMutationVariables>;
export const DeletePasskeyDocument = new TypedDocumentString(`
    mutation DeletePasskey($id: ID!) {
  deletePasskey(id: $id)
}
    `) as unknown as TypedDocumentString<DeletePasskeyMutation, DeletePasskeyMutationVariables>;
export const MeUserSessionsDocument = new TypedDocumentString(`
    query MeUserSessions($userId: ID!) {
  userSessions(userId: $userId) {
    id
    createdAt
    expiresAt
    lastUsedAt
    revokedAt
    ipHash
    loginMethod
    country
    userAgent
    status
  }
}
    `) as unknown as TypedDocumentString<MeUserSessionsQuery, MeUserSessionsQueryVariables>;
export const StartMeshExportDocument = new TypedDocumentString(`
    mutation StartMeshExport($input: StartMeshExportInput!) {
  startMeshExport(input: $input)
}
    `) as unknown as TypedDocumentString<StartMeshExportMutation, StartMeshExportMutationVariables>;
export const ProjectOfflineManifestDocument = new TypedDocumentString(`
    query ProjectOfflineManifest($projectId: ID!) {
  projectOfflineManifest(projectId: $projectId) {
    projectId
    totalBytes
    layerVersions
    files {
      url
      sizeBytes
      layerId
      kind
    }
  }
}
    `) as unknown as TypedDocumentString<ProjectOfflineManifestQuery, ProjectOfflineManifestQueryVariables>;
export const MyOrganizationsDocument = new TypedDocumentString(`
    query MyOrganizations {
  organizations {
    id
    name
    slug
    role
    authBrandingEnabled
    logo {
      url
    }
    storageUsedBytes
    storageLimitBytes
    ephemeralBytes
    subscription {
      productLine
      plan
      isCustom
      maxSeats
      seatsUsed
      billingStatus
      trialEndsAt
    }
  }
}
    `) as unknown as TypedDocumentString<MyOrganizationsQuery, MyOrganizationsQueryVariables>;
export const OrganizationUsersDocument = new TypedDocumentString(`
    query OrganizationUsers {
  users {
    id
    firstName
    lastName
    name
    email
    role
    joinedAt
    createdAt
    avatar {
      url
    }
  }
}
    `) as unknown as TypedDocumentString<OrganizationUsersQuery, OrganizationUsersQueryVariables>;
export const RemoveUserFromOrganizationDocument = new TypedDocumentString(`
    mutation RemoveUserFromOrganization($organizationId: ID!, $userId: ID!) {
  removeUserFromOrganization(organizationId: $organizationId, userId: $userId)
}
    `) as unknown as TypedDocumentString<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>;
export const UpdateUserRoleInOrganizationDocument = new TypedDocumentString(`
    mutation UpdateUserRoleInOrganization($organizationId: ID!, $userId: ID!, $role: UserOrganizationRole!) {
  updateUserRoleInOrganization(
    organizationId: $organizationId
    userId: $userId
    role: $role
  )
}
    `) as unknown as TypedDocumentString<UpdateUserRoleInOrganizationMutation, UpdateUserRoleInOrganizationMutationVariables>;
export const InviteUserToOrganizationDocument = new TypedDocumentString(`
    mutation InviteUserToOrganization($organizationId: ID!, $email: String!, $role: UserOrganizationRole!, $firstname: String!, $lastname: String) {
  inviteUserToOrganization(
    organizationId: $organizationId
    email: $email
    role: $role
    firstname: $firstname
    lastname: $lastname
  )
}
    `) as unknown as TypedDocumentString<InviteUserToOrganizationMutation, InviteUserToOrganizationMutationVariables>;
export const InviteUsersToOrganizationDocument = new TypedDocumentString(`
    mutation InviteUsersToOrganization($organizationId: ID!, $invitees: [InviteUserInput!]!) {
  inviteUsersToOrganization(organizationId: $organizationId, invitees: $invitees)
}
    `) as unknown as TypedDocumentString<InviteUsersToOrganizationMutation, InviteUsersToOrganizationMutationVariables>;
export const OrganizationInvitationsDocument = new TypedDocumentString(`
    query OrganizationInvitations {
  invitations {
    id
    email
    role
    createdAt
    expiresAt
    acceptedAt
  }
}
    `) as unknown as TypedDocumentString<OrganizationInvitationsQuery, OrganizationInvitationsQueryVariables>;
export const RevokeInvitationDocument = new TypedDocumentString(`
    mutation RevokeInvitation($id: ID!) {
  revokeInvitation(id: $id)
}
    `) as unknown as TypedDocumentString<RevokeInvitationMutation, RevokeInvitationMutationVariables>;
export const ResendInvitationDocument = new TypedDocumentString(`
    mutation ResendInvitation($id: ID!) {
  resendInvitation(id: $id)
}
    `) as unknown as TypedDocumentString<ResendInvitationMutation, ResendInvitationMutationVariables>;
export const AcceptInvitationDocument = new TypedDocumentString(`
    mutation AcceptInvitation($token: String!) {
  acceptInvitation(token: $token) {
    success
    error
    organization {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const UpdateOrganizationDocument = new TypedDocumentString(`
    mutation UpdateOrganization($id: ID!, $input: UpdateOrganizationInput!) {
  updateOrganization(id: $id, input: $input) {
    id
    name
    authBrandingEnabled
    logo {
      url
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const DeleteOrganizationDocument = new TypedDocumentString(`
    mutation DeleteOrganization($id: ID!, $password: String!) {
  deleteOrganization(id: $id, password: $password)
}
    `) as unknown as TypedDocumentString<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const CreateOrganizationDocument = new TypedDocumentString(`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    id
    name
    slug
    role
  }
}
    `) as unknown as TypedDocumentString<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const SlugAvailableDocument = new TypedDocumentString(`
    query SlugAvailable($slug: String!) {
  slugAvailable(slug: $slug)
}
    `) as unknown as TypedDocumentString<SlugAvailableQuery, SlugAvailableQueryVariables>;
export const InviteOnboardingUsersDocument = new TypedDocumentString(`
    mutation InviteOnboardingUsers($organizationId: ID!, $invitees: [OnboardingInviteInput!]!, $message: String) {
  inviteOnboardingUsers(
    organizationId: $organizationId
    invitees: $invitees
    message: $message
  )
}
    `) as unknown as TypedDocumentString<InviteOnboardingUsersMutation, InviteOnboardingUsersMutationVariables>;
export const CustomDomainStatusDocument = new TypedDocumentString(`
    query CustomDomainStatus {
  customDomainStatus {
    id
    domain
    status
    cnameTarget
    dnsVerified
    createdAt
    verifiedAt
  }
}
    `) as unknown as TypedDocumentString<CustomDomainStatusQuery, CustomDomainStatusQueryVariables>;
export const AddCustomDomainDocument = new TypedDocumentString(`
    mutation AddCustomDomain($domain: String!) {
  addCustomDomain(domain: $domain) {
    id
    domain
    status
    cnameTarget
    dnsVerified
  }
}
    `) as unknown as TypedDocumentString<AddCustomDomainMutation, AddCustomDomainMutationVariables>;
export const RemoveCustomDomainDocument = new TypedDocumentString(`
    mutation RemoveCustomDomain {
  removeCustomDomain
}
    `) as unknown as TypedDocumentString<RemoveCustomDomainMutation, RemoveCustomDomainMutationVariables>;
export const MyProjectsDocument = new TypedDocumentString(`
    query MyProjects {
  projects {
    id
    name
    srid
    organizationId
    folderId
    storageUsedBytes
    archiveStatus
    archiveBytes
    retentionUntil
  }
}
    `) as unknown as TypedDocumentString<MyProjectsQuery, MyProjectsQueryVariables>;
export const ArchivedProjectsDocument = new TypedDocumentString(`
    query ArchivedProjects {
  archivedProjects {
    id
    name
    organizationId
    archiveStatus
    archivedAt
    archiveBytes
    archiveNonArchivedBytes
    retentionUntil
    restoreRequestedAt
    restoreRetrievedAt
    restoreExpiresAt
    archiveError
    storageUsedBytes
  }
}
    `) as unknown as TypedDocumentString<ArchivedProjectsQuery, ArchivedProjectsQueryVariables>;
export const ArchivePreviewDocument = new TypedDocumentString(`
    query ArchivePreview($projectId: ID!) {
  archivePreview(projectId: $projectId) {
    archivableBytes
    nonArchivableBytes
    archivableFileCount
    nonArchivableFileCount
    monthlyCostCurrent
    monthlyCostArchived
    retrievalFeeEstimate
    quotaAfterArchive
    retentionEndsAt
    blockingJobs {
      id
      type
      status
      label
    }
  }
}
    `) as unknown as TypedDocumentString<ArchivePreviewQuery, ArchivePreviewQueryVariables>;
export const GetProjectDocument = new TypedDocumentString(`
    query GetProject($id: ID!) {
  project(id: $id) {
    id
    name
    description
    srid
    proj4String
    organizationId
    initialPosition
    initialAngle
    defaultThirdPersonView
    archiveStatus
    archiveBytes
    retentionUntil
    storageUsedBytes
    ephemeralBytes
    baseMaps {
      id
      name
      type
      url
      tileSize
      wmsVersion
      wmsLayers
      format
    }
  }
}
    `) as unknown as TypedDocumentString<GetProjectQuery, GetProjectQueryVariables>;
export const SharedLinkDocument = new TypedDocumentString(`
    query SharedLink {
  sharedLink {
    id
    allowQuickUploads
    expiresAt
    hasPassword
  }
}
    `) as unknown as TypedDocumentString<SharedLinkQuery, SharedLinkQueryVariables>;
export const GetSharedProjectDocument = new TypedDocumentString(`
    query GetSharedProject {
  sharedProject {
    id
    name
    srid
    proj4String
    organizationId
    initialPosition
    initialAngle
    defaultThirdPersonView
    baseMaps {
      id
      name
      type
      url
      tileSize
      wmsVersion
      wmsLayers
      format
    }
    organization {
      name
      slug
      logo {
        url
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetSharedProjectQuery, GetSharedProjectQueryVariables>;
export const CreateProjectDocument = new TypedDocumentString(`
    mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    id
    name
    srid
  }
}
    `) as unknown as TypedDocumentString<CreateProjectMutation, CreateProjectMutationVariables>;
export const GetProjectJobsDocument = new TypedDocumentString(`
    query GetProjectJobs($projectId: ID!) {
  jobs(projectId: $projectId) {
    id
    type
    status
    inputJson
    outputJson
    logs
    errorLogs
    startedAt
    completedAt
    estimatedCompletion
    leaseUntil
    attempts
    isLeaf
    batchId
    parentItemId
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetProjectJobsQuery, GetProjectJobsQueryVariables>;
export const GetProjectJobsByBatchDocument = new TypedDocumentString(`
    query GetProjectJobsByBatch($batchId: ID!) {
  jobs: jobsByBatch(batchId: $batchId) {
    id
    type
    status
    inputJson
    outputJson
    logs
    errorLogs
    startedAt
    completedAt
    estimatedCompletion
    leaseUntil
    attempts
    isLeaf
    batchId
    parentItemId
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetProjectJobsByBatchQuery, GetProjectJobsByBatchQueryVariables>;
export const GetProjectLinksDocument = new TypedDocumentString(`
    query GetProjectLinks($projectId: ID!) {
  projectLinks(projectId: $projectId) {
    id
    projectId
    name
    token
    hasPassword
    expiresAt
    createdAt
    createdById
    status
    viewCount
    allowQuickUploads
    ephemeralBytes
    createdBy {
      id
      name
      email
      avatar {
        url
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetProjectLinksQuery, GetProjectLinksQueryVariables>;
export const GetAllProjectLinksDocument = new TypedDocumentString(`
    query GetAllProjectLinks {
  allProjectLinks {
    id
    projectId
    project {
      id
      name
    }
    name
    token
    hasPassword
    expiresAt
    createdAt
    createdById
    status
    viewCount
    allowQuickUploads
    ephemeralBytes
    createdBy {
      id
      name
      email
      avatar {
        url
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAllProjectLinksQuery, GetAllProjectLinksQueryVariables>;
export const ProjectFoldersDocument = new TypedDocumentString(`
    query ProjectFolders {
  projectFolders {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<ProjectFoldersQuery, ProjectFoldersQueryVariables>;
export const CreateProjectFolderDocument = new TypedDocumentString(`
    mutation CreateProjectFolder($name: String!) {
  createProjectFolder(name: $name) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<CreateProjectFolderMutation, CreateProjectFolderMutationVariables>;
export const RenameProjectFolderDocument = new TypedDocumentString(`
    mutation RenameProjectFolder($id: ID!, $name: String!) {
  renameProjectFolder(id: $id, name: $name) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<RenameProjectFolderMutation, RenameProjectFolderMutationVariables>;
export const DeleteProjectFolderDocument = new TypedDocumentString(`
    mutation DeleteProjectFolder($id: ID!) {
  deleteProjectFolder(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteProjectFolderMutation, DeleteProjectFolderMutationVariables>;
export const MoveProjectToFolderDocument = new TypedDocumentString(`
    mutation MoveProjectToFolder($projectId: ID!, $folderId: ID) {
  moveProjectToFolder(projectId: $projectId, folderId: $folderId) {
    id
    folderId
  }
}
    `) as unknown as TypedDocumentString<MoveProjectToFolderMutation, MoveProjectToFolderMutationVariables>;
export const StartRainfallAnalysisDocument = new TypedDocumentString(`
    mutation StartRainfallAnalysis($input: StartRainfallAnalysisInput!) {
  startRainfallAnalysis(input: $input)
}
    `) as unknown as TypedDocumentString<StartRainfallAnalysisMutation, StartRainfallAnalysisMutationVariables>;
export const MyReferralsDocument = new TypedDocumentString(`
    query MyReferrals {
  myReferrals {
    id
    referredEmail
    token
    accountCreatedAt
    organizationCreatedAt
    subscriptionStartedAt
    expiresAt
    createdAt
    referredUser {
      firstName
      lastName
      name
    }
    organization {
      id
      name
      slug
    }
  }
}
    `) as unknown as TypedDocumentString<MyReferralsQuery, MyReferralsQueryVariables>;
export const StartPdfReportDocument = new TypedDocumentString(`
    mutation StartPdfReport($input: StartPdfReportInput!) {
  startPdfReport(input: $input)
}
    `) as unknown as TypedDocumentString<StartPdfReportMutation, StartPdfReportMutationVariables>;
export const SavedViewsDocument = new TypedDocumentString(`
    query SavedViews($projectId: ID!) {
  savedViews(projectId: $projectId) {
    id
    projectId
    name
    description
    visibility
    camera
    clipBox
    visibleLayerIds
    baseMapId
    createdById
    createdAt
    updatedAt
    createdBy {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<SavedViewsQuery, SavedViewsQueryVariables>;
export const SearchProjectsDocument = new TypedDocumentString(`
    query SearchProjects($query: String!) {
  searchProjects(query: $query) {
    id
    name
    description
    organizationId
    organizationName
    organizationSlug
  }
}
    `) as unknown as TypedDocumentString<SearchProjectsQuery, SearchProjectsQueryVariables>;
export const OrganizationWithSubscriptionDocument = new TypedDocumentString(`
    query OrganizationWithSubscription($id: ID!) {
  organization(id: $id) {
    id
    name
    storageUsedBytes
    storageLimitBytes
    subscription {
      productLine
      plan
      isCustom
      maxSeats
      seatsUsed
      billingStatus
      collectionMethod
      billingInterval
      storageLimitBytes
      currentPeriodEnd
      cancelAtPeriodEnd
      cancelAt
      scheduledPlan
      scheduledChangeAt
      trialEndsAt
    }
  }
}
    `) as unknown as TypedDocumentString<OrganizationWithSubscriptionQuery, OrganizationWithSubscriptionQueryVariables>;
export const SubscriptionDetailsDocument = new TypedDocumentString(`
    query SubscriptionDetails($organizationId: ID!) {
  subscriptionDetails(organizationId: $organizationId) {
    info {
      productLine
      plan
      isCustom
      maxSeats
      seatsUsed
      billingStatus
      collectionMethod
      billingInterval
      storageLimitBytes
      currentPeriodEnd
      cancelAtPeriodEnd
      cancelAt
      scheduledPlan
      scheduledChangeAt
      trialEndsAt
    }
    invoices {
      id
      number
      status
      amountDue
      amountPaid
      currency
      created
      dueDate
      hostedInvoiceUrl
      pdfUrl
      taxInvoiceUrl
      taxInvoiceNumber
    }
    nextInvoicePreview {
      amountDue
      currency
      periodStart
      periodEnd
      lines {
        description
        amount
        quantity
      }
    }
    discount {
      promoCodeId
      couponId
      name
      percentOff
      amountOff
      expiresAt
    }
  }
}
    `) as unknown as TypedDocumentString<SubscriptionDetailsQuery, SubscriptionDetailsQueryVariables>;
export const SubscriptionPaymentUrlDocument = new TypedDocumentString(`
    query SubscriptionPaymentUrl($organizationId: ID!) {
  subscriptionPaymentUrl(organizationId: $organizationId)
}
    `) as unknown as TypedDocumentString<SubscriptionPaymentUrlQuery, SubscriptionPaymentUrlQueryVariables>;
export const ValidatePromoCodeDocument = new TypedDocumentString(`
    query ValidatePromoCode($code: String!) {
  validatePromoCode(code: $code) {
    valid
    name
    percentOff
    amountOff
  }
}
    `) as unknown as TypedDocumentString<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>;
export const SubscriptionPricingDocument = new TypedDocumentString(`
    query SubscriptionPricing {
  subscriptionPricing {
    currency
    plans {
      plan
      monthlyAmount
      annualAmount
    }
  }
}
    `) as unknown as TypedDocumentString<SubscriptionPricingQuery, SubscriptionPricingQueryVariables>;
export const StartSurfaceDifferenceDocument = new TypedDocumentString(`
    mutation StartSurfaceDifference($input: StartSurfaceDifferenceInput!) {
  startSurfaceDifference(input: $input)
}
    `) as unknown as TypedDocumentString<StartSurfaceDifferenceMutation, StartSurfaceDifferenceMutationVariables>;
export const SurfaceDifferenceJobsDocument = new TypedDocumentString(`
    query SurfaceDifferenceJobs($projectId: ID!) {
  surfaceDifferenceJobs(projectId: $projectId) {
    id
    status
    label
    batchId
    inputJson
    outputJson
    errorLogs
    createdAt
    startedAt
    completedAt
  }
}
    `) as unknown as TypedDocumentString<SurfaceDifferenceJobsQuery, SurfaceDifferenceJobsQueryVariables>;
export const StartVectorExportDocument = new TypedDocumentString(`
    mutation StartVectorExport($input: StartVectorExportInput!) {
  startVectorExport(input: $input)
}
    `) as unknown as TypedDocumentString<StartVectorExportMutation, StartVectorExportMutationVariables>;